/* exported mapCallbacks */
var mapCallbacks = {};

(function () {
    'use strict';
    angular.module('defaults', [])
        .value('serviceBase', '/eis-services');

    angular.module('core', ['defaults', 'ngCookies', 'ngDialog']);
    angular.module('map', []);
    angular.module('table', []);
    angular.module('filter', []);
    angular.module('edit', ['isteven-multi-select']);
    angular.module('gallery', []);
    angular.module('document', []);
    angular.module('notes', ['ngSanitize']);
    angular.module('validation', []);
    angular.module('roadMeasurements', []);

    var app = angular.module('roadMonitoringObjApp', [
        // libs
        'ngRoute', 'mobile-angular-ui', 'mobile-angular-ui.core.outerClick', 'angucomplete-alt', 'pickadate', 'ngFileUpload',
        'ui.bootstrap.datepickerPopup', 'uib/template/datepicker/datepicker.html', 'uib/template/datepicker/day.html', 'uib/template/datepicker/month.html', 'uib/template/datepicker/year.html', 'uib/template/datepickerPopup/popup.html',
        'ui.bootstrap.timepicker', 'uib/template/timepicker/timepicker.html',
        // app
        'defaults', 'core', 'table', 'map', 'filter', 'edit', 'notes', 'gallery', 'document', 'validation', 'roadMeasurements'
    ]);

    app.config(['$routeProvider', 'pickadateI18nProvider', function ($routeProvider, pickadateI18nProvider) {
        $routeProvider.when('/map', { templateUrl: 'layout/map.html', controller: 'MapController', reloadOnSearch: false });
        $routeProvider.when('/table', { templateUrl: 'layout/table.html', controller: 'TableController', reloadOnSearch: false });
        $routeProvider.when('/login', { templateUrl: 'layout/login.html', controller: 'LoginController', reloadOnSearch: false });
        $routeProvider.when('/table/:id', { templateUrl: 'layout/table.html', controller: 'TableController', reloadOnSearch: false, resolve: {
            validateId: ['$route', '$location', function($route, $location) {
                var id = $route.current.params.id;
                if (!/^\d+$/.test(id)) {
                    $location.path('/map');
                }
            }]
        }});
        $routeProvider.otherwise('/map');

        pickadateI18nProvider.translations = {
            prev: 'Buvęs',
            next: 'Kitas'
        };

    }]);

    app.config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push(['keycloakService', 'serviceBase', function (keycloakService, serviceBase) {
            return {
                'request': function (config) {
                    if (config.url.startsWith(serviceBase)) {
                        config.headers.Authorization = 'Bearer ' + keycloakService.getAccessToken();
                    }
                    return config;
                }

            };
        }]);
    }]);

    app.config(['uibDatepickerPopupConfig', function(uibDatepickerPopupConfig) {
        uibDatepickerPopupConfig.clearText = 'Išvalyti';
        uibDatepickerPopupConfig.closeText = 'Uždaryti';
        uibDatepickerPopupConfig.currentText = 'Šiandien';
    }]);

    app.run(['$rootScope', '$location', 'userService', 'dataConfigService', '$window', function($rootScope, $location, userService, dataConfigService, $window) {
        if ($location.path().indexOf('/login') === -1) {
            var path = $location.path();
            userService.login((path == '' || path.startsWith('/map')) ? null : path).then(function() {
                if (!userService.getPermissions().view) {
                    userService.logout('/login?info=no-rights')
                }
                dataConfigService.setShownColumns();
                $rootScope.$apply();
            })
        }

        angular.element($window).bind('resize', function () {
            dataConfigService.setShownColumns();
            $rootScope.$apply();
        });

    }]);

})();

(function () {
    'use strict';

    angular.module('core')
        .service('IEFallbackService', function () {
            return {
                upload: function (uploadUrl, inputElement, onSuccess) {
                    var iframe = document.createElement('iframe');
                    iframe.setAttribute('id', 'IEupload');
                    iframe.setAttribute('name', 'IEupload');
                    iframe.setAttribute('width', '0');
                    iframe.setAttribute('height', '0');
                    iframe.setAttribute('border', '0');
                    iframe.setAttribute('src', 'javascript:false;');
                    iframe.style.display = 'none';

                    var form = document.createElement('form');
                    form.setAttribute('target', 'IEupload');
                    form.setAttribute('action', uploadUrl);
                    form.setAttribute('method', 'post');
                    form.setAttribute('enctype', 'multipart/form-data');
                    form.setAttribute('encoding', 'multipart/form-data');
                    form.style.display = 'block';

                    form.appendChild(inputElement);

                    document.body.appendChild(form);
                    document.body.appendChild(iframe);
                    var iframeFile = document.getElementById('IEupload');

                    var uploadHandler = function () {
                        if (iframeFile.detachEvent) {
                            iframeFile.detachEvent('onload', uploadHandler);
                        } else {
                            iframeFile.removeEventListener('load', uploadHandler, false);
                        }
                        onSuccess();
                    }

                    if (angular.isDefined(onSuccess)) {
                        if (iframeFile.addEventListener) {
                            iframeFile.addEventListener('load', uploadHandler, true);
                        } else if (iframeFile.attachEvent) {
                            iframeFile.attachEvent('onload', uploadHandler);
                        }
                    }

                    form.submit();
                }
            };
        });

})();

/*global SVGPathElement*/
(function () {
    'use strict';

    var lastStart;

    function touchHandler(event) {
        var first = event.changedTouches[0];
        if (!isMapChild(first.target) || !event.target instanceof SVGPathElement) {
            return;
        }
        if (event.type === 'touchstart') {
            lastStart = Date.now();
            return;
        }
        if (event.type === 'touchend') {
            if (Date.now() - lastStart < 200 && event.target.e_graphic) {
                event.target.graphic = event.target.e_graphic;
                event.target.mapPoint = angular.copy(event.target.e_graphic.geometry);
                first.target.e_graphic._layer.onClick(event.target);
            }
        }

    }

    function isMapChild(element) {
        var svgs = angular.element(document).find('svg');
        for (var i = 0; i < svgs.length; i++) {
            if (svgs[i].id.search('esri.Map') != -1 && svgs[i].contains(element)) {
                return true;
            }
        }
        return false;
    }

    document.addEventListener('touchstart', touchHandler, true);
    document.addEventListener('touchend', touchHandler, true);

})();

(function () {
    'use strict';

    var keycloakConfig = {
        //those values could be changed at runtime
        url: '___RUNTIME_VAR_KEYCLOAK_URL___',
        realm: '___RUNTIME_VAR_KEYCLOAK_REALM___'
    };
    var gazetteerUrl = '___RUNTIME_VAR_GAZETTEER_URL___';
    var runtimeVarFragment = '_RUNTIME_VAR_';
    if (keycloakConfig.url.indexOf(runtimeVarFragment) !== -1) {
        keycloakConfig.url = 'https://keycloak-test.eismoinfo.lt';
    }
    if (keycloakConfig.realm.indexOf(runtimeVarFragment) !== -1) {
        keycloakConfig.realm = 'EIS_TEST';
    }
    if (gazetteerUrl.indexOf(runtimeVarFragment) !== -1) {
        gazetteerUrl = 'https://arcgis-test.vialietuva.lt/gazetteer/search';
    }
    angular.module('core')
        .constant('serviceBase', '/road-monitoring-services')
        .constant('arcgisBase', 'https://eismoinfo.lt/arcgis/rest/services')
        .constant('gazetteerUrl', gazetteerUrl)
        .constant('columnsCookieName', 'RMWVisibleColumns')
        .constant('keycloakConfig', {
            url: keycloakConfig.url,
            realm: keycloakConfig.realm,
            clientId: 'road-monitoring-services',
            responseMode: 'query',
            accessTokenMinValidity: 300
        });
})();


(function () {
    'use strict';
    angular.module('core')
        .controller('BaseController', BaseController);

    BaseController.$inject = ['$scope', '$location', 'DataService', '$rootScope', 'editService', 'ArcGISMap', 'userService', '$filter', 'dataConfigService', 'keycloakService', 'serviceBase'];
    function BaseController($scope, $location, DataService, $rootScope, editService, ArcGISMap, userService, $filter, dataConfigService, keycloakService, serviceBase) {
        $scope.updateAccessToken = function() {
            keycloakService.updateAccessToken();
        }

        $scope.redrawTable = function () {
            $rootScope.$broadcast('redrawTable');
        };

        $scope.isActive = function (route) {
            return route === $location.path();
        };

        $scope.isHideControls = function () {
            return $location.path() === '/login';
        };

        $scope.showMyLocation = function () {
            $scope.myLocation = null;
            editService.getMyLocation(function (position) {
                editService.transformCoordinates(position).success(function (coords) {
                    $scope.showDialog(coords);
                });
            });
        };

        $scope.searchStringChange = function() {
            $rootScope.$broadcast('newSearchString', $scope.searchString);
        };

        $scope.$on('searchStringRequest', function() {
            $rootScope.$broadcast('newSearchString', $scope.searchString);
        });

        $scope.$on('openLocationDialog', function($event, coords) {
            $scope.showDialog(coords);
        });

        $scope.showDialog = function (coords) {
            editService.resolveRoad(coords.geometries[0].x, coords.geometries[0].y).success(function (userRoad) {
                $scope.positionOnRoad = userRoad;
                editService.resolveRoadByNumber(userRoad.kelionr).success(function (road) {
                    $rootScope.Ui.turnOn('myLocation');
                    var distanceToRoad = Math.sqrt(Math.pow((coords.geometries[0].x - userRoad.x), 2)
                        + Math.pow((coords.geometries[0].y - userRoad.y), 2));

                    if (distanceToRoad < 150) {
                        $scope.myLocation = {
                            kelioId: road[0].id,
                            kelioPavadinimas: road[0].pavadinimas,
                            kelioNumeris: road[0].numeris,
                            kelias: road[0].numeris + ' ' + road[0].pavadinimas,
                            kmNuo: parseFloat(userRoad.km.toFixed(3)),
                            km: $filter('number')(userRoad.km, 2) + ' km',
                            keliokryptis: userRoad.keliokryptis == 'AB' ? 'Abiem' :
                                (userRoad.keliokryptis == 'PR' ? 'Pirmyn' : (userRoad.keliokryptis == 'AT' ? 'Atgal' : '')),
                            distanceToRoad: Math.round(distanceToRoad) + 'm',
                            x: parseFloat(userRoad.x.toFixed(2)),
                            y: parseFloat(userRoad.y.toFixed(2)),
                            canCreateNew: true
                        };
                    } else {
                        $scope.myLocation = {
                            kelias: '-',
                            km: '-',
                            keliokryptis: '-',
                            distanceToRoad: 'Aplink nėra valstybinės reikšmės kelio',
                            x: coords.geometries[0].x,
                            y: coords.geometries[0].y,
                            canCreateNew: false
                        };
                    }

                    editService.resolveAddress($scope.myLocation.x, $scope.myLocation.y).success(function (addresses) {
                        var nearest = { distance: Number.MAX_VALUE };
                        angular.forEach(addresses.response.docs, function (address) {
                            if (address.distance && address.distance < nearest.distance) {
                                nearest = address;
                            }
                        });
                        $scope.myLocation.adresas = nearest.name + ' ' + nearest.description;
                    });
                    ArcGISMap.showMyLocation(coords.geometries[0].x, coords.geometries[0].y);
                });
            });
        };

        $scope.clearMyLocation = function () {
            ArcGISMap.hideMyLocation();
        }

        $scope.setObjectData = function () {
            $scope.myLocation.xnuo = $scope.myLocation.x;
            $scope.myLocation.ynuo = $scope.myLocation.y;
            ArcGISMap.hideMyLocation();
            editService.obj = $scope.myLocation;
        }

        $scope.exportPdf = function() {
            /* eslint-disable camelcase */
            DataService.downloadFilePost(
                serviceBase + '/reports',
                'defektai.pdf',
                { p_report_name: 'defektai', p_app_name: 'defects', p_defs: getDefectIds() }
            );
        }

        $scope.exportCsv = function () {
            return DataService.getCSV($scope.searchString);
        };

        $scope.exportXlsx = function () {
            /* eslint-disable camelcase */
            DataService.downloadFilePost(
                serviceBase + '/reports',
                'defektai.xlsx',
                { p_report_name: 'defektai_excel', p_app_name: 'defects', p_defs: getDefectIds() }
            );
        };

        function getDefectIds() {
            var data = $filter('filter')(DataService.getData(), function(element) { return DataService.filterData(element, $scope.searchString); });
            var selectedRecsArray = $filter('filter')(data, function(element) { return element.selectedRec == true });
            if (selectedRecsArray.length > 0) {
                data = selectedRecsArray;
            }
            data = $filter('orderBy')(data, dataConfigService.getOrder());
            var defectIds = '';
            _.forEach(data, function (item, index) {
                if (index > 0) {
                    defectIds += ',';
                }
                defectIds += item.id
            });
            return defectIds;
        }

        $scope.hasRole = function (role) {
            return userService.getPermissions()[role];
        };

        $scope.hasAnyRole = function (roles) {
            return _.find(roles, function (role) {
                return $scope.hasRole(role);
            }) ? true : false;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('core')
        .service('dataConfigService', dataConfigService);

    dataConfigService.$inject = ['$cookies', '$window', 'columnsCookieName'];
    function dataConfigService($cookies, $window, columnsCookieName) {
        var that = this;
        var LT = '<', LTE = '<=', GT = '>', GTE = '>=', EQ = '=', NEQ = '<>', LIKE = 'LIKE', IN = 'IN';
        this.config = [
            getParameterObj('road.id', 'Kelio Nr', 'kelioNumeris', 'road', true, '+', [EQ, NEQ], null, 'kelioSvarba'),
            getParameterObj('kelioPavadinimas', 'Kelias', 'kelioPavadinimas', null, true, '', null, 620),
            getParameterObj('kmFrom', 'Km nuo', 'kmNuo', 'number', true, '+', [EQ, NEQ, LT, LTE, GT, GTE], null),
            getParameterObj('kmTo', 'Km iki', 'kmIki', 'number', true, '', [EQ, NEQ, LT, LTE, GT, GTE], null),
            getParameterObj('address', 'Adresas', 'adresas', 'text', true, '', [EQ, NEQ, LIKE], 1300),
            getParameterObj('re.division.id', 'Regionas', 'regionuPavadinimai', 'regions', true, '', [EQ, NEQ], 1000, 'regionuPavadinimai'),
            getParameterObj('rs.division.id', 'Tarnyba', 'tarnybuPavadinimai', 'services', true, '', [EQ, NEQ], 900, 'tarnybuPavadinimai'),
            getParameterObj('ma.division.id', 'Meistrija', 'meistrijuPavadinimai', 'masteries', true, '', [EQ, NEQ], 900, 'meistrijuPavadinimai'),
            getParameterObj('vi.possibleViolation.id', 'Pažeidimai', 'defektuGrupiuPavadinimai', 'violations', true, '', [EQ, NEQ], 470, 'defektuGrupiuPavadinimai'),
            getParameterObj('defectStatus', 'Defekto statusas', 'defektoStatusas', 'status', true, '', [EQ, NEQ, IN], 425, 'defektoStatusas'),
            getParameterObj('workType', 'Darbų rūšis', 'darbuRusisMeaning', 'workType', true, '', [EQ, NEQ], 425, 'darbuRusisMeaning'),
            getParameterObj('inspectionDate', 'Apžiūros data', 'apziurosData', 'date', true, '', [EQ, NEQ, LT, LTE, GT, GTE], 750, null, 2),
            getParameterObj('decisionDate', 'Sprendimo data', 'sprendimoData', 'date', true, '', [EQ, NEQ, LT, LTE, GT, GTE], 750, null, 2),
            getParameterObj('updateDate', 'Redagavimo data', 'redagavimoData', 'date', false, '', [EQ, NEQ, LT, LTE, GT, GTE], 0, null, 1),
            getParameterObj('author.id', 'Sukūręs naudotojas', 'sukuresNaudotojas', 'user', true, '', [EQ, NEQ], 1100, 'sukuresNaudotojas'),
            getParameterObj('description', 'Aprašymas', 'aprasymas', 'text', true, '', [LIKE], 620),
            getParameterObj('statusChangeDate', 'Paskutinė statuso keitimo data', 'statusoKeitimoData', 'date', true, '', [EQ, NEQ, LT, LTE, GT, GTE], 750, null, 2),
        ];

        this.setShownColumns = setShownColumns;
        this.setColumnsToCookie = setColumnsToCookie;
        this.getOrder = getOrder;

        ////////////////

        function setShownColumns() {
            var cookie = $cookies.get(columnsCookieName);
            if (cookie) {
                var columns = cookie.split(';');
                _.forEach(that.config, function (configColumn) {
                    configColumn.show = _.includes(columns, configColumn.variable);
                });
            } else {
                _.forEach(that.config, function (configColumn) {
                    if (configColumn.show) {
                        configColumn.show = configColumn.minWidth == null || configColumn.minWidth < $window.innerWidth;
                    }
                });
            }
        }

        function setColumnsToCookie() {
            var cookieValue = '';
            _.forEach(that.config, function (column) {
                if (column.show) {
                    cookieValue += column.variable + ';';
                }
            });

            $cookies.put(columnsCookieName, cookieValue);
        }

        function getParameterObj(parameter, parameterName, variable, type, show, order, operands, minWidth, orderColumn, isDate) {
            return {
                parameter: parameter,
                parameterName: parameterName,
                variable: variable,
                show: show,
                order: order,
                orderColumn: orderColumn,
                type: type,
                operands: operands,
                minWidth: minWidth,
                isDate: isDate
            }
        }

        function getOrder() {
            var result = [];
            angular.forEach(that.config, function (column) {
                if (column.order !== '') {
                    result.push(column.order + (column.orderColumn ? column.orderColumn : column.variable));
                }
            })
            return result;
        }

    }
})();

(function () {
    'use strict';

    angular.module('core')
        .service('DataService', ['$q', '$rootScope', '$http', '$filter', 'serviceBase', 'dataConfigService', 'dialogService', function ($q, $rootScope, $http, $filter, serviceBase, dataConfigService, dialogService) {
            var _data = [],
                _regions = [],
                _roadServices = [],
                _masteries = [],
                _violations = [],
                _notesTypes = [],
                _status = [],
                _workTypes = [],
                _currentObj = {},
                _descriptionTexts = {};

            var __regionsIdValueMapper = [],
                __roadServicesIdValueMapper = [],
                __masteriesIdValueMapper = [],
                __violationsIdValueMapper = [];

            function formMultichoiceFields() {
                if (_data
                    && _regions && _regions.length > 0
                    && _roadServices && _roadServices.length > 0
                    && _masteries && _masteries.length > 0
                    && _violations && _violations.length > 0) {
                    angular.forEach(_data, function (item) {
                        item.regionuPavadinimai = '';
                        item.tarnybuPavadinimai = '';
                        item.meistrijuPavadinimai = '';
                        item.defektuGrupiuPavadinimai = '';

                        item.defektuGrupiuPavadinimai = item.pazeidimai
                            .map(function (violationId) { return __violationsIdValueMapper[violationId]; })
                            .join(', ');
                        item.regionuPavadinimai = item.regionai
                            .map(function (regionId) { return __regionsIdValueMapper[regionId]; })
                            .join(', ');
                        item.tarnybuPavadinimai = item.tarnybos
                            .map(function (roadServiceId) { return __roadServicesIdValueMapper[roadServiceId]; })
                            .join(', ');
                        item.meistrijuPavadinimai = item.meistrijos
                            .map(function (masteryId) { return __masteriesIdValueMapper[masteryId]; })
                            .join(', ');
                    });
                }
            }

            function resetClassifiers() {
                _regions = [];
                _roadServices = [];
                _masteries = [];
                _violations = [];
                _notesTypes = [];
                _status = [];
                _workTypes = [];
                _currentObj = {};
                _descriptionTexts = [];

                __regionsIdValueMapper = [];
                __roadServicesIdValueMapper = [];
                __masteriesIdValueMapper = [];
                __violationsIdValueMapper = [];
            }

            function formFilterInValue(filters) {
                if (filters.length !== 0) {
                    angular.forEach(filters, function(filter) {
                        if (filter.operand === 'IN') {
                            if (!filter.valuesArray || !filter.valuesArray.length) {
                                filter.value = '()';
                                return;
                            }
                            filter.value = '(';
                            for (var i = 0; i < filter.valuesArray.length; i++) {
                                filter.value += filter.valuesArray[i];
                                if (i < filter.valuesArray.length - 1) {
                                    filter.value += ', ';
                                }
                            }
                            filter.value += ')';
                        }
                    });
                }
            }

            function undToEmpty(str) {
                if (angular.isUndefined(str) || str == null) {
                    return '';
                }
                return str;
            }
            return {
                getData: function () {
                    if (_data) {
                        return _data;
                    }
                },
                refreshData: function (filters) {
                    var filtersCopy = angular.copy(filters);
                    formFilterInValue(filtersCopy);
                    $http.post(serviceBase + '/road-monitoring/filter', filtersCopy).
                        success(function (data) {
                            if (data.error) {
                                _data = [];
                                alert('Dėmesio: jūsų nurodyti filtravimo kriterijai atrinko ' + data.objectsCount +
                                    ' rezultatų, kai maksimalus galimas kiekis yra ' + data.availableRecsCount +
                                    '. Prašome susiaurinti paiešką patikslinus filtro parametrus.');
                            } else {
                                _data = data.data;
                                formMultichoiceFields();
                                $rootScope.$emit('reloadTable');
                            }
                        }).
                        error(function () {
                            _data = [];
                        });
                },
                getNotesType: function () {
                    return _notesTypes;
                },
                getRegions: function () {
                    return _regions;
                },
                getRoadServices: function () {
                    return _roadServices;
                },
                getMasteries: function () {
                    return _masteries;
                },
                getViolations: function () {
                    return _violations;
                },
                getStatus: function () {
                    return _status;
                },
                getWorkTypes: function () {
                    return _workTypes;
                },
                getDescriptionTexts: function () {
                    return _descriptionTexts;
                },
                setCurrentObject: function (obj) {
                    _currentObj = obj;
                },
                getCurrentObject: function () {
                    return _currentObj;
                },
                getResolvedStatusId: function () {
                    var id;
                    for (var i = 0; i < _status.length; i++) {
                        var element = _status[i];
                        if (element.meaning === 'Išspręstas') {
                            id = element.id;
                            break;
                        }
                    }
                    return id;
                },
                isIE: function () {
                    var myNav = navigator.userAgent.toLowerCase();
                    return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
                },
                filterData: function (element, filterString) {
                    if (!filterString || !filterString.length) {
                        return true;
                    }
                    var str = filterString.toLowerCase();
                    return ('idx' + element.id) == str || element.kelioNumeris.toLowerCase().indexOf(str) != -1 ||
                        element.kelioPavadinimas.toLowerCase().indexOf(str) != -1 ||
                        ('' + element.kmNuo).toLowerCase().indexOf(str) != -1 ||
                        ('' + element.kmIki).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.adresas).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.regionuPavadinimai).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.tarnybuPavadinimai).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.meistrijuPavadinimai).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.defektuGrupiuPavadinimai).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.defektoStatusas.meaning).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty($filter('date')(element.apziurosData)).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty($filter('date')(element.sprendimoData)).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.sukuresNaudotojas).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.aprasymas).toLowerCase().indexOf(str) != -1 ||
                        undToEmpty(element.darbuRusis).toLowerCase().indexOf(str) != -1;
                },
                filterSelected: function (el) {
                    return el.selectedRec;
                },
                getCSV: function (filterString) {
                    var arrData = typeof _data != 'object' ? JSON.parse(_data) : _data;
                    var self = this;
                    arrData = $filter('filter')(arrData, function (element) { return self.filterData(element, filterString); });
                    var selectedRecsArray = $filter('filter')(arrData, function (el) { return self.filterSelected(el) });
                    if (selectedRecsArray.length > 0) {
                        arrData = selectedRecsArray;
                    }
                    var CSV = '';
                    var row = '';
                    var skip = [];
                    for (var index in arrData[0]) {
                        for (var i = 0; i < dataConfigService.config.length; i++) {
                            if (dataConfigService.config[i].variable === index) {
                                row += dataConfigService.config[i].parameterName + ';';
                                break;
                            }
                            if (i === dataConfigService.config.length - 1) {
                                skip.push(index);
                            }
                        }
                    }
                    row = row.slice(0, -1);
                    CSV += row + '\r\n';

                    for (var i = 0; i < arrData.length; i++) {
                        var row = '';
                        for (var index in arrData[i]) {
                            if (skip.indexOf(index) !== -1)
                                continue;
                            if (
                                arrData[i][index] !== null
                                && (index === 'apziurosData' || index === 'sprendimoData' || index === 'redagavimoData')
                            ) {
                                var date = new Date(arrData[i][index]);
                                row += '"' + date.getFullYear()
                                    + '.' + this.padNumberWithZero(date.getMonth() + 1)
                                    + '.' + this.padNumberWithZero(date.getDate())
                                    + ' ' + this.padNumberWithZero(date.getHours())
                                    + ':' + this.padNumberWithZero(date.getMinutes())
                                    + ':' + this.padNumberWithZero(date.getSeconds())
                                    + '";';
                            } else {
                                var fieldValue = arrData[i][index];
                                if (typeof fieldValue === 'string') {
                                    fieldValue = fieldValue.replace(/(\r\n|\n|\r)/gm, '');
                                }
                                row += '"' + fieldValue + '";';
                            }
                        }
                        row.slice(0, row.length - 1);
                        CSV += row + '\r\n';
                    }

                    if (CSV == '') {
                        alert('Invalid data');
                        return;
                    }

                    if (typeof Int8Array !== 'undefined') {
                        var orderMark = new Int8Array(3); //adding the UTF-8 byte order mark, so that MS Excel will recognize UTF chars
                        orderMark[0] = 0xEF;
                        orderMark[1] = 0xBB;
                        orderMark[2] = 0xBF;
                    }

                    var fileName = 'KeliuPrieziurosObjektai';
                    var link = document.createElement('a');

                    if (this.isIE() < 10 && navigator.appName == 'Microsoft Internet Explorer') {
                        var ielink = window.open('about:blank', '_blank');
                        ielink.document.write('sep=;\r\n' + CSV);
                        ielink.document.close();
                        ielink.focus();
                        ielink.document.execCommand('SaveAs', true, fileName);
                        ielink.close();
                    }
                    else if (navigator.msSaveBlob) {
                        var blob = new Blob([orderMark, CSV], { type: 'text/csv;' });
                        navigator.msSaveBlob(blob, fileName + '.csv');
                    }
                    else {
                        if (link.download !== undefined) {
                            var blob = new Blob([orderMark, CSV], { type: 'text/csv;' });
                            var url = URL.createObjectURL(blob);
                            link.setAttribute('href', url);
                            link.setAttribute('download', fileName + '.csv');
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                    }
                },
                loadClassifiers: function () {
                    resetClassifiers();

                    return $q.all([
                        $http.get(serviceBase + '/road-monitoring/resource/notes-type').
                            success(function (data) {
                                _notesTypes = data;
                            }).
                            error(function () {
                                _notesTypes = [];
                            }),

                        $http.get(serviceBase + '/resource/divisions?type=REGION')
                            .success(function (data) {
                                _regions = data;
                                angular.forEach(data, function (value) {
                                    __regionsIdValueMapper[value.id] = value.pavadinimas;
                                });
                                formMultichoiceFields();
                            })
                            .error(function () {
                                _regions = [];
                            }),
                        $http.get(serviceBase + '/resource/divisions?type=ROAD_SERVICE')
                            .success(function (data) {
                                _roadServices = data;
                                angular.forEach(data, function (value) {
                                    __roadServicesIdValueMapper[value.id] = value.pavadinimas;
                                });
                                formMultichoiceFields();
                            })
                            .error(function () {
                                _roadServices = [];
                            }),
                        $http.get(serviceBase + '/resource/divisions?type=MASTERY')
                            .success(function (data) {
                                _masteries = data;
                                angular.forEach(data, function (value) {
                                    __masteriesIdValueMapper[value.id] = value.pavadinimas;
                                });
                                formMultichoiceFields();
                            })
                            .error(function () {
                                _masteries = [];
                            }),


                        $http.get(serviceBase + '/road-monitoring/resource/status').
                            success(function (data) {
                                _status = data;
                            }).
                            error(function () {
                                _status = [];
                            }),

                        $http.get(serviceBase + '/road-monitoring/resource/violations').
                            success(function (data) {
                                _violations = data.map(function (el) {
                                    if (el.aprasymas === 'nenaudojamas') {
                                        el.disabled = true;
                                    }
                                    return el;
                                });
                                angular.forEach(data, function (item) {
                                    __violationsIdValueMapper[item.id] = item.pazeidimas;
                                });
                            }).
                            error(function () {
                                _violations = [];
                            }),

                        $http.get(serviceBase + '/road-monitoring/resource/work-type').
                            success(function (data) {
                                _workTypes = data;
                            }).
                            error(function () {
                                _workTypes = [];
                            }),
                        $http.get(serviceBase + '/road-monitoring/resource/description-texts').
                            success(function (data) {
                                _descriptionTexts = data;
                            }).
                            error(function () {
                                _descriptionTexts = [];
                            })
                    ]);
                },
                downloadFileGet: function (url, fileName) {
                    this.downloadFile(fileName, $http.get(url, { responseType: 'arraybuffer' }))
                },
                downloadFilePost: function(url, fileName, requestData) {
                    this.downloadFile(fileName, $http.post(url, requestData, { responseType: 'arraybuffer' }));
                },
                downloadFile: function (fileName, promise) {
                    function onSuccess(response) {
                        if ('drple' in response.headers()) {
                            var headerValue = response.headers('drple');
                            if (headerValue.includes('zero')) {
                                dialogService.error('Atfiltruotų įrašų sąrašas negali būti tusčias.');
                            } else {
                                var parts = headerValue.split(',');
                                var limit = parts[0].split(':')[1];
                                var currentLength = parts[1].split(':')[1];
                                dialogService.error(
                                    'Per didelis įrašų kiekis. Maksimumas: ' + limit + '. '
                                    + 'Parinkta: ' + currentLength
                                );
                            }
                            return;
                        }

                        var contentType = response.headers('content-type') || 'application/octet-stream';
                        var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                        if (urlCreator) {
                            var blob = new Blob([response.data], { type: contentType });
                            var url = urlCreator.createObjectURL(blob);
                            var link = document.createElement('a');
                            link.setAttribute('href', url);
                            link.setAttribute('download', fileName);
                            setTimeout(function () {
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(url);
                            });
                        } else {
                            alert('Nepavyko suformuoti atsisiuntimo nuorodos');
                            // eslint-disable-next-line no-console
                            console.error('urlCreator does not exists!');
                        }
                    }

                    function onError(error) {
                        dialogService.error('Nepavyko paruošti failo.');
                        // eslint-disable-next-line no-console
                        console.error(error);
                    }

                    dialogService.reportExportBlockingDialog(promise.then(onSuccess).catch(onError));
                },
                padNumberWithZero: function (number) {
                    return number < 10 ? '0' + number : number;
                }
            };
        }]);
})();

(function () {
    'use strict';

    angular.module('core').filter('decimal', function () {
        return function (input, places) {
            if (isNaN(input)) return input;
            var factor = '1' + Array(+(places > 0 && places + 1)).join('0');
            return Math.round(input * factor) / factor;
        };
    });

})();

(function () {
    'use strict';

    angular.module('core')
        .directive('focusMe', ['$timeout', function ($timeout) {
            return {
                link: function (scope, element, attrs) {
                    var value = attrs.focusMe == 'true';
                    if (value) {
                        $timeout(function () {
                            // If element is wrapping the input focus obj, we need to find real focus obj
                            if (element.find('input').length > 0) {
                                element.find('input')[0].focus();
                            } else {
                                element[0].focus();
                            }
                        });
                    }
                }
            };
        }]);

})();

(function () {
    'use strict';

    //cool shortcuts like key combinations are not supported
    //unless a need arises, they will not be implemented

    angular.module('core')
        .service('KeypressService', ['$rootScope', '$document', function ($rootScope, $document) {

            $rootScope.listeners = [];
            $rootScope.lastId = 0;

            $rootScope.idExists = function (id) {//return the index+1 of object with id equal to argument
                for (var i = 0; i < $rootScope.listeners.length; i++) {//so that if an object was found
                    if ($rootScope.listeners[i].id === id)//the returned value would always be >0,
                        return i + 1;//thus enabling the return value to be used as a boolean
                }
                return 0;
            };

            $document.bind('keydown', function (event) {//pass event and listener id to on event callback
                for (var i = 0; i < $rootScope.listeners.length; i++) {//id is passed, so that one-time eventListeners could unregister themselves.
                    if ($rootScope.listeners[i].keyCode == event.keyCode) {
                        $rootScope.listeners[i].callback(event, $rootScope.listeners[i].id);
                    }
                }
            });

            return {
                registerKeypressListener: function (keycode, callback) {
                    var listener = {};
                    if ($rootScope.listeners.length === 0) {
                        listener.id = 0;
                        $rootScope.lastId = 0;
                    }
                    else listener.id = $rootScope.lastId++;
                    listener.keyCode = keycode;
                    listener.callback = callback;
                    $rootScope.listeners.push(listener);
                    return listener.id;

                },
                unregisterKeypressListener: function (id) {
                    var index = $rootScope.idExists(id);
                    if (index) {
                        $rootScope.listeners.splice(index - 1, 1);
                        return true;
                    }
                    else //no such listener
                    {
                        return false;
                    }
                }
            };
        }]);

})();

(function () {
    'use strict';

    angular.module('core').directive('onlyNumbers', function() {
      return {
        link: function(scope, element) {
          element.on('keypress', function(event) {
            if (event.key && !/[\d\.\b\t]/.test(event.key) && !event.ctrlKey) {
              event.preventDefault();
            }
            if (event.key === '.' && element.val().indexOf('.') !== -1) {
              event.preventDefault();
            }
          });

          element.on('paste', function(event) {
            event.preventDefault();
            var pastedText = (event.originalEvent || event).clipboardData.getData('text/plain');
            var output = handlePasteLocation(element, deleteExtraDots(pastedText.replace(/[^\d.]/g, '')));
            var ngModelCtrl = element.controller('ngModel');
            ngModelCtrl.$setViewValue(output.output);
            ngModelCtrl.$render();
            element[0].setSelectionRange(output.cursorPosition, output.cursorPosition);
          });

          function deleteExtraDots(output) {
            var parts = output.split('.');
            return parts[0] + (parts.length > 1 ? '.' + parts.slice(1).join('') : '');
          }

          function handlePasteLocation(element, textToPaste) {
            var currentValue = element.val();
            var selectionStart = element[0].selectionStart;
            var textBefore = currentValue.substring(0, selectionStart);
            var textAfter = currentValue.substring(element[0].selectionEnd);
            if (textBefore.indexOf('.') != -1 || textAfter.indexOf('.') != -1) {
              textToPaste = textToPaste.replace(/\./g, '');
            }
            return { output: textBefore + textToPaste + textAfter, cursorPosition: selectionStart + textToPaste.length };
          }
        }
      };
    });

})();

(function () {
    'use strict';

    // overrides library factory to fix datepicker popup position.

    angular.module('pickadate')
        .factory('pickadateModalBindings', ['$window', '$document', function ($window, $document) {

            var computeStyles = function (element) {
                var topOffset = element.getAttribute('top-offset');

                return { top: (topOffset ? topOffset : element.offsetParent.offsetHeight) + 'px' };
            };

            var isDescendant = function (parent, child) {
                var node = child.parentNode;
                while (node !== null) {
                    if (node === parent) return true;
                    node = node.parentNode;
                }
                return false;
            };

            return function (scope, element, rootNode) {
                var togglePicker = function (toggle) {
                    scope.displayPicker = toggle;
                    scope.$apply();
                };

                element.on('focus', function () {
                    scope.modalStyles = computeStyles(element[0]);
                    togglePicker(true);
                });

                element.on('keydown', function (e) {
                    if (indexOf.call([9, 13, 27], e.keyCode) >= 0) togglePicker(false);
                });

                $document.on('click', function (e) {
                    if (isDescendant(rootNode, e.target) || e.target === element[0]) return;
                    togglePicker(false);
                });
            };

        }]);

})();

(function () {
  'use strict';
  var mod = angular.module('core');

  mod.directive('radio', [directiveInit]);

  function directiveInit() {
      function link(scope) {
          var hasLabel = Boolean(scope.labelProperty);
          scope.getLabel = function(data) {
              if(hasLabel) {
                  return data[scope.labelProperty];
              } else {
                  return data;
              }
          };
          if (!scope.model) {
            scope.model = scope.defaultValue;
          }
      }

      return {
          restrict: 'E',
          link: link,
          templateUrl: 'layout/radioTemplate.html',
          scope: {
              values: '=',
              model: '=',
              labelProperty: '@?',
              trackProperty: '@?',
              defaultValue: '@?',
              name: '@?',
          }
      };
  }
})();


(function () {
    'use strict';
    angular.module('core')
        .service('userService', userService);

    userService.$inject = ['DataService', 'FilterService', 'dialogService', 'keycloakService'];
    function userService(DataService, FilterService, dialogService, keycloakService) {
        var service = this;
        service.permissions = {};

        return {
            login: login,
            logout: logout,
            getPermissions: getPermissions,
            canEditObject: canEditObject
        };

        function getPermissions() {
            return service.permissions;
        }

        function logout(path) {
            keycloakService.logout(path);
        }

        function canEditObject(objectCreatedByCurrentUser) {
            return service.permissions.editAll || (service.permissions.edit && objectCreatedByCurrentUser);
        }

        function login(path) {
            return keycloakService.login(path).then(function() {
                var resourceAccess = keycloakService.getResourceAccess();
                var permissions = resourceAccess ? resourceAccess.roles : [];
                service.permissions = {
                    view: permissions.includes('RM:V'),
                    viewAll: permissions.includes('RM:VA'),
                    edit: permissions.includes('RM:E'),
                    editAll: permissions.includes('RM:EA'),
                    resolveDateEdit: permissions.includes('RM_RD:E'),
                    resolveDateEditForKD: permissions.includes('RM_RD_KD:E'),
                    seenByLakd: permissions.includes('RM_SBL:E'),
                }

                DataService.loadClassifiers().then(function () {
                    DataService.refreshData(FilterService.filters);
                });
            }, function() {
                dialogService.error('Nepavyko prisijungti.');
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('document')
        .service('DocumentConfigService', DocumentConfigService);

    DocumentConfigService.$inject = ['serviceBase'];
    function DocumentConfigService(serviceBase) {
        return {
            deleteDocumentPath: serviceBase + '/road-monitoring/document/remove/',
            uploadDocumentPath: serviceBase + '/road-monitoring/document/',
            getDocumentListPath: serviceBase + '/road-monitoring/document/',
            getDocumentPath: serviceBase + '/road-monitoring/document/'
        };
    }
})();

(function () {
    'use strict';

    angular.module('document')
        .controller('DocumentController', [
            '$scope',
            'DocumentService',
            'userService',
            documentController]);

    function documentController($scope, DocumentService) {
        $scope.object = DocumentService.getCurrentObject();
    }

})();

(function () {
    'use strict';

    angular.module('document')
        .directive('document', ['DataService', function (DataService) {
            return {
                restrict: 'E',
                templateUrl: 'layout/documentTemplate.html',
                scope: {
                    fileName: '=',
                    url: '=',
                    enableDelete: '=',
                    remove: '&onRemovePress'
                },
                link: function (scope) {
                    scope.word = false, scope.excel = false, scope.text = false,
                        scope.pdf = false, scope.unknown = false, scope.powerpoint = false,
                        scope.image = false;
                    scope.$watch('fileName', function () {
                        if (typeof scope.fileName !== 'string') {
                            return;
                        }
                        var extension = scope.fileName.match(/\.(.*?$)/);
                        if (extension === null || extension.length < 2) {
                            extension = '';
                        } else {
                            extension = extension[1];
                        }
                        //add logic to determine file type.
                        switch (extension) {
                            case 'doc':
                            case 'docx':
                            case 'odt':
                                scope.word = true;
                                break;
                            case 'xls':
                            case 'xlsx':
                            case 'ods':
                                scope.excel = true;
                                break;
                            case 'ppt':
                            case 'pptx':
                            case 'odp':
                                scope.powerpoint = true;
                                break;
                            case 'txt':
                            case 'ini':
                                scope.text = true;
                                break;
                            case 'pdf':
                                scope.pdf = true;
                            case 'jpg':
                            case 'jpeg':
                            case 'png':
                            case 'bmp':
                                scope.image = true;
                            default:
                                scope.unknown = true;
                                break;
                        }
                    });

                    scope.downloadFile = function() {
                        DataService.downloadFileGet(scope.url, scope.fileName);
                    }
                }
            };
        }]);

})();

(function () {
    'use strict';

    directiveController.$inject = ['$scope', 'DocumentService', 'DocumentConfigService', 'dialogService', 'userService'];
    angular.module('document')
        .directive('documentList', documentList);

    function documentList() {
        return {
            restrict: 'E',
            templateUrl: 'layout/documentListTemplate.html',
            scope: {
                object: '=',
                onSuccess: '&'
            },
            controller: directiveController
        };
    }

    function directiveController($scope, DocumentService, DocumentConfigService, dialogService, userService) {
        init();
        $scope.$on('refreshDocuments', reloadData);
        $scope.enableDelete = userService.canEditObject($scope.object.createdByCurrentUser);

        var currentDialog = document.getElementById('document-dialog');

        function init() {
            $scope.documents = [];
            $scope.loading = true;
            $scope.config = DocumentConfigService;
            reloadData();
        }

        function reloadData() {
            DocumentService.getDocumentList($scope.object.id, function (data) {
                $scope.documents = data;
                $scope.object.dokumentuKiekis = data.length;
                $scope.loading = false;
            }, function () {
                dialogService.error('Įvyko klaida kraunant dokumentų sąrašą.');
                $scope.loading = false;
            });
        }

        $scope.removeDocument = function (fileName) {
            dialogService.confirm('Ar tikrai norite ištrinti ' + fileName + '?', null, 'Trinti')
                .then(function () {
                    DocumentService.deleteDocument($scope.object.id, fileName, function (data) {
                        switch (data.status) {
                            case 'ERROR':
                                dialogService.error('Įvyko klaida trinant dokumentą.');
                                break;
                            case 'NOT_FOUND':
                                dialogService.error('Dokumentas nerastas.');
                                break;
                        }
                        reloadData();
                        if ($scope.onSuccess) {
                            $scope.onSuccess();
                        }
                    }, function () {
                        dialogService.error('Įvyko klaida trinant dokumentą.');
                    });
                });
        }

        currentDialog.addEventListener('dragover', function (e) { // checking if can drag file drom dekstop
            e = e || event;
            if (e.target.id != 'document-input-image') {
                e.preventDefault();
                e.dataTransfer.effectAllowed = 'none';
                e.dataTransfer.dropEffect = 'none';
            }
        }, false);

        currentDialog.addEventListener('drop', function (e) { // checking if can drop file drom dekstop
            e = e || event;
            if (e.target.id != 'document-input-image') {
                e.preventDefault();
                e.dataTransfer.effectAllowed = 'none';
                e.dataTransfer.dropEffect = 'none';
            }
        }, false);


        $scope.$watch('files', function () {
            $scope.upload($scope.files);
        });

        $scope.upload = function (files) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    DocumentService.uploadDocuments($scope.object.id, $scope.inputElement, file, false, $scope.onSuccess);
                }
            }
        };

        $scope.canDeleteDocument = function(document) {
            return userService.canEditObject(document.createdByCurrentUser);
        }
    }
})();

(function () {
    'use strict';

    angular.module('document')
        .service('DocumentService', ['$rootScope', '$http', 'DocumentConfigService', 'IEFallbackService', 'dialogService', function ($rootScope, $http, DocumentConfigService, IEFallbackService, dialogService) {
                var object = {};

                return {
                    ////////////////
                    getCurrentObject: function () {
                        return object;
                    },
                    ////////////////
                    setCurrentObject: function (obj) {
                        object = obj;
                    },
                    ////////////////
                    deleteDocument: function (ID, fileName, onSuccess, onError) {
                        $http.delete(DocumentConfigService.deleteDocumentPath + ID + '/' + btoa(fileName))
                            .success(function (data, status, headers, config) {
                                if (angular.isDefined(onSuccess)) {
                                    onSuccess(data, status, headers, config);
                                }
                            })
                            .error(function (data, status, headers, config) {
                                if (angular.isDefined(onError)) {
                                    onError(data, status, headers, config);
                                }
                            });
                    },
                    ////////////////
                    getDocumentList: function (objectID, onSuccess, onError) {
                        $http.get(DocumentConfigService.getDocumentListPath + objectID)
                            .success(function (data, status, headers, config) {
                                if (angular.isDefined(onSuccess)) {
                                    onSuccess(data, status, headers, config);
                                }
                            })
                            .error(function (data, status, headers, config) {
                                if (angular.isDefined(onError)) {
                                    onError(data, status, headers, config);
                                }
                            });
                    },
                    ////////////////
                    getDocument: function (docId, onSuccess, onError) {
                        $http.get(DocumentConfigService.getDocumentPath + docId)
                            .success(function (data, status, headers, config) {
                                if (angular.isDefined(onSuccess)) {
                                    onSuccess(data, status, headers, config);
                                }
                            })
                            .error(function (data, status, headers, config) {
                                if (angular.isDefined(onError)) {
                                    onError(data, status, headers, config);
                                }
                            });
                    },
                    ////////////////
                    uploadDocuments: function (OID, inputElement, droppedFile, overwrite, onSuccess) {
                        var that = this;
                        if (typeof FormData === 'undefined') {//IE fallback
                            if (droppedFile !== null) inputElement = droppedFile;
                            IEFallbackService.upload(DocumentConfigService.uploadDocumentPath + OID + '/' + overwrite, inputElement, onSuccess);
                            return;
                        }

                        var formData = new FormData();
                        if (droppedFile === null) {
                            for (var i = 0; i < inputElement.files.length; i++) {
                                formData.append('file', inputElement.files[i]);
                            }
                        } else {
                            formData.append('file', droppedFile);
                        }

                        $http.post(DocumentConfigService.uploadDocumentPath + OID + '/' + overwrite, formData, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': undefined }
                        }).success(function (data) {
                            if (data.insufficientPrivileges) {
                                dialogService.error('Nepakanka teisių');
                            } else if (data.hasError) {
                                dialogService.error('Įvyko klaida prisegant dokumentą.');
                            } else if (data.needsPermission) {
                                dialogService.confirmCustom('layout/dialogs/documentOverwriteDialog.html', data.results)
                                    .then(function () {
                                        if (droppedFile === null) {
                                            that.uploadDocuments(OID, inputElement, null, true, onSuccess);
                                        } else {
                                            that.uploadDocuments(OID, null, droppedFile, true, onSuccess);
                                        }
                                    });
                            }
                            $rootScope.$broadcast('refreshDocuments');
                            if (onSuccess) {
                                onSuccess();
                            }
                        }).error(function () {
                            if (angular.isDefined(onError)) {
                                $rootScope.$broadcast('refreshDocuments');
                                dialogService.error('Įvyko klaida prisegant dokumentą.');
                            }
                        });
                    }
                };
            }]);

})();

(function () {
    'use strict';

    angular.module('edit')
        .service('editConfigService', editConfigService);

    editConfigService.$inject = ['serviceBase', 'arcgisBase', 'gazetteerUrl'];
    function editConfigService(serviceBase, arcgisBase, gazetteerUrl) {
        return {
            SaveObject: serviceBase + '/road-monitoring/save',
            UpdateStatus: serviceBase + '/road-monitoring/on-read/',
            JsonTransformCoords: arcgisBase + '/Utilities/Geometry/GeometryServer/project',
            JsonResolveRoad: arcgisBase + '/LakisKelioInfo/MapServer/exts/LakisKelioInfoSOE/kelioInfoByXY?x=',
            JsonResolveCoords: arcgisBase + '/LakisKelioInfo/MapServer/exts/LakisKelioInfoSOE/kelioInfoByKm?kelionr=',
            DeleteObject: serviceBase + '/road-monitoring/delete/',
            GetAddress: gazetteerUrl + '?skip=stop&limit=50&x=',
            changeStatus: serviceBase + '/road-monitoring/change-status',
            getHistory: serviceBase + '/road-monitoring/get-history',
            getObjectById: serviceBase + '/road-monitoring/get-object/',
            roadDivisions: serviceBase + '/road/divisions',
            roadSearch: serviceBase + '/road/search?p=',
            statusMap: {
                DATM: { DISP: false, DNAU: false, DATM: false, DSPR: false, DLAP: true },
                DISP: { DISP: false, DNAU: true, DATM: false, DSPR: false, DLAP: true },
                DNAU: { DISP: true, DNAU: false, DATM: true, DSPR: true, DLAP: true },
                DPER: { DISP: true, DNAU: false, DATM: true, DSPR: true, DLAP: true },
                DSPR: { DISP: true, DNAU: false, DATM: true, DSPR: false, DLAP: true },
                DLAP: { DISP: true, DNAU: true, DATM: true, DSPR: true, DLAP: false }
            },
            defaultStatusLowValue: 'DNAU',
            maxDistance: 150
        };
    }
})();

(function () {
    'use strict';

    angular.module('edit')
        .controller('EditController', editController);

    editController.$inject = ['$scope', 'FilterService', '$timeout', 'editService', 'editConfigService', 'DataService', 'GalleryService', 'DocumentService', 'NotesService', 'dialogService', 'userService', 'SharedState', '$window'];
    function editController($scope, FilterService, $timeout, editService, editConfigService,
        DataService, GalleryService, DocumentService, NotesService, dialogService, userService, SharedState, $window) {

        $scope.listMaximized = true;
        $scope.fromCoordsError = {};
        $scope.toCoordsError = {};
        function activate() {

            if (editService.obj !== null) {
                $scope.keliuPrieziurosObjektas = editService.obj;
                editService.obj = null;

                NotesService.resetNotes();
                NotesService.obj = angular.copy($scope.keliuPrieziurosObjektas);
                if (angular.isDefined(NotesService.obj.id)) {
                    NotesService.loadNotes();
                }
                $scope.note = {
                    noteText: null,
                    noteType: NotesService.getKTTITypeId(),
                    notesTypes: DataService.getNotesType()
                };

                if (angular.isDefined($scope.keliuPrieziurosObjektas.id)) {
                    $scope.disableEdit = !(userService.getPermissions().editAll
                        || (userService.getPermissions().edit && $scope.keliuPrieziurosObjektas.createdByCurrentUser));

                }
                if (angular.isDefined($scope.keliuPrieziurosObjektas.id)) {
                    $scope.disableEditUser = !(userService.getPermissions().edit && $scope.keliuPrieziurosObjektas.createdByCurrentUser);

                }

                $scope.disableSeenByLakd = !userService.getPermissions().seenByLakd;
                $scope.disableResolveDate = isResolveDateDisabled();

                if ($scope.keliuPrieziurosObjektas.kelioId != null
                    // if creating object from map then tarnybos and padaliniai are undefined and therefore needs to resolve lists
                    && !$scope.keliuPrieziurosObjektas.tarnybos && !$scope.keliuPrieziurosObjektas.padaliniai) {
                    resolveLists();
                }

                if ($scope.keliuPrieziurosObjektas.apziurosData) {
                    $scope.keliuPrieziurosObjektas.apziurosData = new Date($scope.keliuPrieziurosObjektas.apziurosData);
                }
                if ($scope.keliuPrieziurosObjektas.sprendimoData) {
                    $scope.keliuPrieziurosObjektas.sprendimoData = new Date($scope.keliuPrieziurosObjektas.sprendimoData);
                }

                $scope.loadHistory();
            } else {
                $scope.keliuPrieziurosObjektas = {
                    /*init data*/
                    apziurosData: new Date()
                };
            }
            $scope.regions = _.orderBy(editService.getWithSelected($scope.keliuPrieziurosObjektas.regionai, DataService.getRegions()), 'pavadinimas');
            $scope.roadServices = _.orderBy(editService.getWithSelected($scope.keliuPrieziurosObjektas.tarnybos, DataService.getRoadServices()), 'pavadinimas');
            $scope.masteries = _.orderBy(editService.getWithSelected($scope.keliuPrieziurosObjektas.meistrijos, DataService.getMasteries()), 'pavadinimas');
            $scope.violations = _.orderBy(editService.getWithSelected($scope.keliuPrieziurosObjektas.pazeidimai, DataService.getViolations()), 'pazeidimas');
            $scope.status = DataService.getStatus();
            $scope.workTypes = DataService.getWorkTypes();
            $scope.aprasymasTexts = DataService.getDescriptionTexts();
            $scope.currentTab = 0;
            $scope.notEmpty = $scope.keliuPrieziurosObjektas.id !== undefined && $scope.keliuPrieziurosObjektas.id !== null;
            $scope.statusConfig = editConfigService.statusMap;

            if (!$scope.keliuPrieziurosObjektas.apziurosData) {
                $scope.keliuPrieziurosObjektas.apziurosData = new Date();
            }

            if ($scope.keliuPrieziurosObjektas.defektoStatusas === undefined) {
                DataService.getStatus().forEach(function (element) {
                    if (element.lowValue == editConfigService.defaultStatusLowValue) {
                        $scope.keliuPrieziurosObjektas.defektoStatusasLowValue = element.lowValue;
                        $scope.keliuPrieziurosObjektas.defektoStatusas = element.meaning;
                    }
                })
            }

            $scope.localLang = editService.getMultiselectTranslations();
            $scope.options = editService.getDatepickerOptions();

            if ($scope.keliuPrieziurosObjektas.cameFromMap) {
                $scope.handleFromCoordsChange();
            }
        }

        $scope.loadHistory = function () {
            editService.getHistory($scope.keliuPrieziurosObjektas.id).then(function (response) {
                $scope.history = response.data;
            }, function () { });
        }

        $scope.selectRoad = function (data) {
            if (data) {
                $scope.keliuPrieziurosObjektas.kelioNumeris = data.originalObject.numeris;
                $scope.keliuPrieziurosObjektas.kelioPavadinimas = data.originalObject.pavadinimas;
                $scope.keliuPrieziurosObjektas.kelioId = data.originalObject.id;
                $scope.objKelias = data.originalObject;
                $scope.keliuPrieziurosObjektas.kmNuo = $scope.objKelias.kmNuo;
                $scope.keliuPrieziurosObjektas.kmIki = $scope.objKelias.kmIki;
                $scope.maxKm = $scope.objKelias.kmIki;
                $scope.minKm = $scope.objKelias.kmNuo;
                resolveFromCoords();
                resolveToCoords();
                resetToCoordsErrors();
                resetFromCoordsErrors();
                resolveLists();
            } else {
                $scope.keliuPrieziurosObjektas.kelioNumeris = null;
                $scope.keliuPrieziurosObjektas.kelioPavadinimas = null;
                $scope.keliuPrieziurosObjektas.kelioId = null;
                $scope.objKelias = null;
            }

        };

        $scope.handleFromKmChange = _.debounce(function() {
            resetFromCoordsErrors();
            resolveFromCoords();
            resolveLists();

            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }, 300);

        $scope.handleToKmChange = _.debounce(function() {
            resetToCoordsErrors();
            resolveToCoords();
            resolveLists();

            if (!$scope.$$phase) {
                $scope.$apply();
            }
          }, 300);

        $scope.handleFromCoordsChange = function () {
            if (editService.coordsInExtent($scope.keliuPrieziurosObjektas.xnuo, $scope.keliuPrieziurosObjektas.ynuo)) {
                editService.resolveRoad($scope.keliuPrieziurosObjektas.xnuo, $scope.keliuPrieziurosObjektas.ynuo).success(function (road) {
                    if (road.kelionr == $scope.keliuPrieziurosObjektas.kelioNumeris) {
                        $scope.keliuPrieziurosObjektas.kmNuo = editService.round(road.km, 2);
                        $scope.fromCoordsError.wrongRoad = false;
                    } else {
                        $scope.fromCoordsError.wrongRoad = true;
                        $scope.keliuPrieziurosObjektas.kmNuo = null;
                        $scope.fromCoordsError.roadNr = road.kelionr;
                    }
                    $scope.keliuPrieziurosObjektas.fromDistanceToRoad = editService.round(
                        editService.distanceBetweenPoints(
                            $scope.keliuPrieziurosObjektas.xnuo,
                            $scope.keliuPrieziurosObjektas.ynuo,
                            road.x,
                            road.y),
                        1);
                    resolveLists();
                    resolveAddress();
                });
            } else {
                resetFromCoordsErrors();
            }
        }

        $scope.handleToCoordsChange = function () {
            $scope.toCoordsError.wrongRoad = false;
            if (editService.coordsInExtent($scope.keliuPrieziurosObjektas.xiki, $scope.keliuPrieziurosObjektas.yiki)) {
                editService.resolveRoad($scope.keliuPrieziurosObjektas.xiki, $scope.keliuPrieziurosObjektas.yiki).success(function (road) {
                    if (road.kelionr == $scope.keliuPrieziurosObjektas.kelioNumeris) {
                        $scope.toCoordsError.wrongCoords = false;
                        $scope.keliuPrieziurosObjektas.kmIki = editService.round(road.km, 2);
                    } else {
                        $scope.toCoordsError.wrongRoad = true;
                        $scope.keliuPrieziurosObjektas.kmIki = null;
                        $scope.toCoordsError.roadNr = road.kelionr;
                    }
                    $scope.keliuPrieziurosObjektas.toDistanceToRoad = editService.round(
                        editService.distanceBetweenPoints(
                            $scope.keliuPrieziurosObjektas.xiki,
                            $scope.keliuPrieziurosObjektas.yiki,
                            road.x,
                            road.y),
                        1);
                    resolveLists();
                });
            } else {
                resetToCoordsErrors();
            }
        }

        //////////////////////////////////////

        function isResolveDateDisabled() {
          var disableEdit = $scope.disableEdit;
          var resolveDateEditForKDRecs = userService.getPermissions().resolveDateEditForKD;
          var resolveDateEdit = userService.getPermissions().resolveDateEdit;

          if (disableEdit || (!resolveDateEditForKDRecs && !resolveDateEdit)) {
            return true;
          }

          if ($scope.keliuPrieziurosObjektas.darbuRusis === 'KD') {
            return !resolveDateEditForKDRecs;
          } else {
            return !resolveDateEdit;
          }

        }

        function resolveFromCoords() {
            editService.resolveCoordinates($scope.keliuPrieziurosObjektas.kelioNumeris, $scope.keliuPrieziurosObjektas.kmNuo)
                .success(function (data) {
                    $scope.keliuPrieziurosObjektas.xnuo = editService.round(data.x, 2);
                    $scope.keliuPrieziurosObjektas.ynuo = editService.round(data.y, 2);
                    resolveAddress();
                });
        }

        function resolveToCoords() {
            editService.resolveCoordinates($scope.keliuPrieziurosObjektas.kelioNumeris, $scope.keliuPrieziurosObjektas.kmIki)
                .success(function (data) {
                    $scope.keliuPrieziurosObjektas.xiki = editService.round(data.x, 2);
                    $scope.keliuPrieziurosObjektas.yiki = editService.round(data.y, 2);
                });
        }

        function resolveAddress() {
            editService.resolveAddress($scope.keliuPrieziurosObjektas.xnuo, $scope.keliuPrieziurosObjektas.ynuo).success(function (addresses) {
                var nearest = { distance: Number.MAX_VALUE };
                angular.forEach(addresses.response.docs, function (address) {
                    if (address.distance && address.distance < nearest.distance) {
                        nearest = address;
                    }
                });
                $scope.keliuPrieziurosObjektas.adresas = nearest.name + ' ' + nearest.description;
            });
        }

        function resetFromCoordsErrors() {
            $scope.fromCoordsError.wrongRoad = false;
            $scope.fromCoordsError.wrongCoords = false;
            $scope.keliuPrieziurosObjektas.fromDistanceToRoad = 0;
        }

        function resetToCoordsErrors() {
            $scope.toCoordsError.wrongRoad = false;
            $scope.toCoordsError.wrongCoords = false;
            $scope.keliuPrieziurosObjektas.toDistanceToRoad = 0;
        }

        function resolveLists() {
            editService.resolveRoadDivisions($scope.keliuPrieziurosObjektas)
                .then(function (response) {
                    selectListElements($scope.regions, response.data.regions);
                    selectListElements($scope.roadServices, response.data.roadServices);
                    selectListElements($scope.masteries, response.data.masteries);
                });
        }

        function selectListElements(listElements, selectedElemets) {
            angular.forEach(listElements, function (listElement) {
                listElement.selected = selectedElemets.includes(listElement.id);
            });
        }

        $scope.getMyLocationFrom = function () {
            editService.getMyLocation(function (position) {
                editService.transformCoordinates(position).success(function (coords) {
                    editService.resolveRoad(coords.geometries[0].x, coords.geometries[0].y).success(function (userRoad) {
                        editService.resolveRoadByNumber(userRoad.kelionr).success(function (road) {
                            if ($scope.keliuPrieziurosObjektas.kelioId !== road[0].id) {
                                dialogService.confirm('Kelias kuriame esate yra kitas, nei prieš tai buvęs, ar norite pakeisti kelią?', '', 'Pakeisti')
                                    .then(function () {
                                        $scope._changePlaceFrom(road[0], userRoad, true);
                                    });
                            } else {
                                $scope._changePlaceFrom(road[0], userRoad, false);
                            }
                        });
                    });
                });
            });
        };

        $scope.getMyLocationTo = function () {
            editService.getMyLocation(function (position) {
                editService.transformCoordinates(position).success(function (coords) {
                    editService.resolveRoad(coords.geometries[0].x, coords.geometries[0].y).success(function (userRoad) {
                        editService.resolveRoadByNumber(userRoad.kelionr).success(function (road) {
                            if ($scope.keliuPrieziurosObjektas.kelioId !== road[0].id) {
                                dialogService.confirm('Kelias kuriame esate yra kitas, nei prieš tai buvęs, ar norite pakeisti kelią?', '', 'Pakeisti')
                                    .then(function () {
                                        $scope._changePlaceTo(road[0], userRoad, true);
                                    });
                            } else {
                                $scope._changePlaceTo(road[0], userRoad, false);
                            }
                        });
                    });
                });
            });
        };

        $scope.save = function () {
            $scope.savingInProgress = true;

            function showError(message) {
                $scope.savingInProgress = false;
                return dialogService.error(message);
            }

            $scope.keliuPrieziurosObjektas.regionai = [];
            if ($scope.selectedRegions && $scope.selectedRegions.length > 0) {
                angular.forEach($scope.selectedRegions, function (item) {
                    $scope.keliuPrieziurosObjektas.regionai.push(item.id);
                });
            } else {
                return showError('Regionų sąrašas yra tuščias!');
            }

            $scope.keliuPrieziurosObjektas.tarnybos = [];
            if ($scope.selectedServices && $scope.selectedServices.length > 0) {
                angular.forEach($scope.selectedServices, function (item) {
                    $scope.keliuPrieziurosObjektas.tarnybos.push(item.id);
                });
            } else {
                return showError('Tarnybų sąrašas yra tuščias!');
            }

            $scope.keliuPrieziurosObjektas.meistrijos = [];
            if ($scope.selectedMasteries && $scope.selectedMasteries.length > 0) {
                angular.forEach($scope.selectedMasteries, function (item) {
                    $scope.keliuPrieziurosObjektas.meistrijos.push(item.id);
                });
            } else {
                return showError('Meistrijų sąrašas yra tuščias!');
            }

            $scope.keliuPrieziurosObjektas.pazeidimai = [];
            if ($scope.selectedViolations && $scope.selectedViolations.length > 0) {
                angular.forEach($scope.selectedViolations, function (item) {
                    $scope.keliuPrieziurosObjektas.pazeidimai.push(item.id);
                });
            } else {
                return showError('Defektų grupių sąrašas yra tuščias!');
            }

            var kmNuo = parseFloat($scope.keliuPrieziurosObjektas.kmNuo);
            var kmIki = parseFloat($scope.keliuPrieziurosObjektas.kmIki);

            if (!kmNuo) {
              return showError('Neįvestas kilometras Nuo');
            }

            if ($scope.minKm > kmNuo || kmNuo > $scope.maxKm ) {
              $scope.savingInProgress = false;
              return showError('Kilometras Nuo turi būti skaičius nuo ' + $scope.minKm + ' iki ' + $scope.maxKm);
            }

            if (kmIki && ($scope.minKm > kmIki || kmIki > $scope.maxKm) ) {
              return showError('Kilometras Iki turi būti skaičius nuo ' + $scope.minKm + ' iki ' + $scope.maxKm);
            }

            if (kmIki && kmNuo > kmIki) {
                return showError('Kilometras Nuo, viršija kilometrą Iki');
            }

            if ($scope.keliuPrieziurosObjektas.fromDistanceToRoad > editConfigService.maxDistance
                || $scope.keliuPrieziurosObjektas.toDistanceToRoad > editConfigService.maxDistance
                || $scope.fromCoordsError.wrongRoad
                || $scope.toCoordsError.wrongRoad) {
                return showError('Atstumas tarp kelio ir taško viršija ' + editConfigService.maxDistance + 'm, arba taškas(-ai) nėra prie nurodyto kelio.');
            }

            editService.save($scope.keliuPrieziurosObjektas)
                .success(function (data) {
                    $scope.clear();
                    DataService.refreshData(FilterService.filters);
                    editService.obj = data;
                    activate();
                    dialogService.success('Objektas išsaugotas.', '');
                })
                .error(function (data, status) {
                    if(status === 400 && data.message) {
                        dialogService.error(data.message);
                        return;
                    }
                    dialogService.error(status === 403 ? 'Nepakanka teisių redaguoti šį objektą' : 'Įvyko klaida saugant objektą');
                })
                .finally(function() {
                    $scope.savingInProgress = false;
                });
        };


        $scope.onWindowResize = function () { //handle window resizing (make sure, that the image does not overflow under the floating list)
            var bottom = document.getElementById('gallery-bottom').getBoundingClientRect().bottom;
            document.getElementById('gallery-modal-dialog').style.height = window.innerHeight - 200 + 'px';
            if ($scope.listMaximized)
                bottom -= bottom * 0.25; //subtract the thumb container height
            else bottom -= 25; //bottom position - padding
            var imagedropBoxRect = document.getElementById('image-display').getBoundingClientRect();
            if (imagedropBoxRect.top == 0)
                document.getElementById('image-display').style.maxHeight = window.innerHeight - 200 + 'px';
            else
                document.getElementById('image-display').style.maxHeight = (bottom - imagedropBoxRect.top - 20) + 'px';
        };

        $scope.clear = function () {
            $scope.selectedRegions = [];
            $scope.selectedRoadServices = [];
            $scope.selectedMasteries = [];
            $scope.selectedMeans = [];
        };

        $scope.getAutocompleteUrl = function () {
            return editConfigService.roadSearch;
        }

        $scope.confirmRemove = function () {
            dialogService.confirm('Ar tikrai norite ištrinti šitą defektą?').then(function () {
                editService.remove($scope.keliuPrieziurosObjektas.id).success(function () {
                    SharedState.turnOff('edit');
                    DataService.refreshData(FilterService.filters);
                }).error(function (data, status) {
                    dialogService.error(status === 403 ? 'Nepakanka teisių' : 'Įvyko klaida trinant objektą');
                });
            });
        };

        $scope._changePlaceFrom = function (road, userRoad, clearOther) {
            $scope.$broadcast('angucomplete-alt:changeInput', 'road', road.numeris + ' ' + road.pavadinimas);
            $scope.selectRoad({ originalObject: road });
            $timeout(function () {
                $scope.keliuPrieziurosObjektas.xnuo = userRoad.x;
                $scope.keliuPrieziurosObjektas.ynuo = userRoad.y;
                $scope.keliuPrieziurosObjektas.kmNuo = Math.round(userRoad.km*1000) / 1000;

                if (clearOther) {
                    $scope.keliuPrieziurosObjektas.xiki = null;
                    $scope.keliuPrieziurosObjektas.yiki = null;
                    $scope.keliuPrieziurosObjektas.kmIki = null;
                }
            }, 500);
        };

        $scope._changePlaceTo = function (road, userRoad, clearOther) {
            $scope.$broadcast('angucomplete-alt:changeInput', 'road', road.numeris + ' ' + road.pavadinimas);
            $scope.selectRoad({ originalObject: road });
            $timeout(function () {
                $scope.keliuPrieziurosObjektas.xiki = userRoad.x;
                $scope.keliuPrieziurosObjektas.yiki = userRoad.y;
                $scope.keliuPrieziurosObjektas.kmIki = Math.round(userRoad.km*1000) / 1000;

                if (clearOther) {
                    $scope.keliuPrieziurosObjektas.xnuo = null;
                    $scope.keliuPrieziurosObjektas.ynuo = null;
                    $scope.keliuPrieziurosObjektas.kmNuo = null;
                }
            }, 500);
        };

        $scope.uploadPicture = function (element) {
            GalleryService.uploadImages($scope.keliuPrieziurosObjektas.id, element, null, function () {
                $scope.$broadcast('refreshGallery');
                $scope.loadHistory();
            });
        };

        $scope.uploadDocument = function (element) {
            DocumentService.uploadDocuments($scope.keliuPrieziurosObjektas.id, element, null, false);
            $scope.loadHistory();
        }

        $scope.saveNote = function () {
            var obj = {
                tipasId: $scope.note.noteType,
                tekstas: $scope.note.noteText,
                kelioPrieziurosObjektoId: $scope.keliuPrieziurosObjektas.id
            };
            NotesService.save(obj).then(function () {
                $scope.loadHistory();
            });
            NotesService.obj.pastabuKiekis++;
            $scope.note.noteText = null;
            $scope.$broadcast('reloadNotes');
        }

        $scope.changeStatusConfig = function (statusValue) {
            editService.changeStatus({ obj: $scope.keliuPrieziurosObjektas.id, lowValue: statusValue }).then(function (response) {
                $scope.keliuPrieziurosObjektas.defektoStatusasLowValue = response.data.defektoStatusasLowValue;
                $scope.keliuPrieziurosObjektas.defektoStatusas = response.data.defektoStatusas;
                DataService.refreshData(FilterService.filters);
                $scope.loadHistory();
            }, function (response) {
                dialogService.error(response.data)
            });
        }

        $scope.setIssprendimoData = function (days, months) {
            var issprendimoData = new Date($scope.keliuPrieziurosObjektas.apziurosData);

            issprendimoData.setDate(issprendimoData.getDate() + days);
            issprendimoData.setMonth(issprendimoData.getMonth() + months);

            $scope.keliuPrieziurosObjektas.sprendimoData = issprendimoData;
        }

        $scope.addTextForAprasymas = function (text) {
            $scope.keliuPrieziurosObjektas.aprasymas =
                $scope.keliuPrieziurosObjektas.aprasymas ? $scope.keliuPrieziurosObjektas.aprasymas + ' ' + text : text;
        }

        $scope.changeWorkType = function (selectedViolations) {
          if($scope.keliuPrieziurosObjektas.darbuRusis !== 'KD') {
            angular.forEach(selectedViolations, function(el) {
              if (el.aprasymas === 'nelegali veikla') {
                $scope.keliuPrieziurosObjektas.darbuRusis = 'KD';
              }
            });
          }
        }

        $scope.updateResolveDatePermissions = function () {
          $scope.disableResolveDate = isResolveDateDisabled();
        }

        $scope.openUrl = function (url) {
            if(url) {
                $window.open(url, '_blank');
            }
        }

        activate();

    }
})();

(function () {
    'use strict';

    angular.module('edit')
        .service('editService', ['$http', 'editConfigService', 'dialogService', '$q', function ($http, editConfigService, dialogService, $q) {

            return {
                obj: null,
                save: function (keliuPrieziurosObjektas) {
                    return $http.put(editConfigService.SaveObject, keliuPrieziurosObjektas);
                    },
                updateStatus: function (keliuPrieziurosObjektas) {
                    return $http.put(editConfigService.UpdateStatus + keliuPrieziurosObjektas.id);
                },
                changeStatus: function (status) {
                    return $http.post(editConfigService.changeStatus, status);
                },
                getHistory: function (id) {
                    return $http.get(editConfigService.getHistory, {params:{id: id}});
                },
                resolveRoadDivisions: function (kpo) {
                    var params = {roadId: kpo.kelioId, kmFrom: kpo.kmNuo, kmTo: kpo.kmIki}
                    return $http.get(editConfigService.roadDivisions, {params: params});
                },
                getMyLocation: function (callback) {
                    if(!navigator.geolocation) {
                        dialogService.error('Jūsų naršyklė nepalaiko buvimo vietos nustatymo funkcijos.');
                        return;
                    }
                    var options = {
                        enableHighAccuracy: true,
                        timeout: 120000,
                        maximumAge: 0
                    };
                    var location = null;
                    var watchId = null;
                    var progress = $q.defer();
                    var success = function(pos) {
                        if(location == null || location.coords.accuracy > pos.coords.accuracy) {
                            progress.notify('Bandome nustatyti Jūsų buvimo vietą... Tikslumas '+(pos.coords.accuracy | 0)+' m');
                            location = pos;
                        }
                    };
                    var error = function() {
                        progress.reject('Įvyko klaida bandant nustatyti Jūsų buvimo vietą');
                    };
                    var timeoutId;
                    var args = {
                        progress: function(progress) {
                            args.$scope.ngDialogData.text = progress;
                            args['ready'] = true;
                        },
                        useCoords: function() {
                            progress.resolve();
                            args.$scope.closeThisDialog();
                            navigator.geolocation.clearWatch(watchId);
                            callback(location);
                            clearTimeout(timeoutId);
                        }
                    };
                    dialogService.customBlockingDialog('layout/dialogs/geolocationDialog.html', args, progress.promise, null, 'Bandome nustatyti Jūsų buvimo vietą...');
                    watchId = navigator.geolocation.watchPosition(success, error, options);
                    timeoutId = setTimeout(function() {
                        if(location == null) {
                            error();
                        } else {
                            args.useCoords();
                        }
                        navigator.geolocation.clearWatch(watchId);
                    }, 120000);
                },
                transformCoordinates: function (position) {
                    var data = {
                        inSR: 4326,
                        outSR: 3346,
                        geometries: {
                            geometryType: 'esriGeometryPoint',
                            geometries: [
                                {
                                    x: position.coords.longitude,
                                    y: position.coords.latitude
                                }
                            ]
                        },
                        transformation: '',
                        transformForward: false,
                        vertical: false,
                        f: 'pjson',
                        callback: 'JSON_CALLBACK'
                    };
                    return $http.jsonp(editConfigService.JsonTransformCoords, { params: data });
                },
                resolveRoadByNumber: function (number) {
                    return $http.get(editConfigService.roadSearch + number);
                },
                resolveRoad: function (x, y) {
                    return $http.jsonp(editConfigService.JsonResolveRoad + x + '&y=' + y + '&tolerance=10000&rastizenkla=&f=pjson&callback=JSON_CALLBACK');
                },
                resolveCoordinates: function (pRoadNr, pKm) {
                    return $http.jsonp(editConfigService.JsonResolveCoords + pRoadNr + '&km=' + pKm + '&kryptis=AB&f=pjson&callback=JSON_CALLBACK');
                },
                remove: function (id) {
                    return $http.delete(editConfigService.DeleteObject + id);
                },
                resolveAddress: function (x, y) {
                    return $http.get(editConfigService.GetAddress + x + '&y=' + y);
                },
                getWithSelected: function (idArray, itemsArray) {
                    var result = angular.copy(itemsArray);
                    angular.forEach(idArray, function (id) {
                        angular.forEach(result, function (item) {
                            if (item.id === id) {
                                item.selected = true;
                            }
                        });
                    });
                    return result;
                },
                getDatepickerOptions: function () {
                    return {
                        monthsFull: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
                        monthsShort: ['Sau', 'Vas', 'Kov', 'Bal', 'Geg', 'Bir', 'Lie', 'Rgp', 'Rgs', 'Spa', 'Lap', 'Gru'],
                        weekdaysFull: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
                        weekdaysShort: ['Sek', 'Pir', 'Ant', 'Tre', 'Ket', 'Pen', 'Šeš'],
                        today: 'Šiandien',
                        clear: 'Išvalyti',
                        close: 'Uždaryti',
                        labelMonthNext: 'Sekantis mėnuo',
                        labelMonthPrev: 'Praeitas mėnuo',
                        labelMonthSelect: 'Pasirinkite mėnesį',
                        labelYearSelect: 'Pasirinkite metus',
                        format: 'yyyy-mm-dd',
                        firstDay: 1
                    };
                },
                getMultiselectTranslations: function () {
                    return {
                        selectAll: 'Pažymėti visus',
                        selectNone: 'Atšaukti',
                        reset: 'Atšaukti visus',
                        search: 'Norėdami ieškoti rašykite...',
                        nothingSelected: 'Niekas nepasirinkta'
                    };
                },
                distanceBetweenPoints: function (x1, y1, x2, y2) {
                    return Math.sqrt(Math.pow((x1 - x2), 2) + Math.pow((y1 - y2), 2));
                },
                round: function (number, decimalPlaces) {
                    return Math.round(number * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
                },
                coordsInExtent: function (x, y) {
                    return x > 300000 && x < 690000 && y > 5970000 && y < 6260000;
                },
                getObjectById: function(id) {
                    return $http.get(editConfigService.getObjectById + id);
                }
            };
        }]);
})();

(function () {
    'use strict';

    angular.module('filter')
        .service('filterConfigService', filterConfigService);

    filterConfigService.$inject = ['serviceBase'];
    function filterConfigService(serviceBase) {
        return {
            roadAutocompleteURL: serviceBase + '/road/search?p=',
            userAutocompleteURL: serviceBase + '/user/search?p='
        };
    }
})();

(function () {

    'use strict';

    angular.module('filter')
        .controller('FilterController', ['$scope', 'FilterService', 'DataService', function ($scope, FilterService, DataService) {
                $scope.isOpen = false;
                $scope.dataService = DataService;
                $scope.filter = {
                    parameter: '',
                    operand: null,
                    operation: 'AND',
                    value: '',
                    type: ''
                };

                if (FilterService.filters.length === 0) {
                    FilterService.filters.push(angular.copy($scope.filter));
                }

                $scope.toggleDropdown = function(filter) {
                    filter.isMultiselectOpen = !filter.isMultiselectOpen;
                };

                $scope.isInValueSelected = function(filter, item) {
                    if (filter.operand === 'IN' && filter.valuesArray && filter.valuesArray.length > 0) {
                        for (var j = 0; j < filter.valuesArray.length; j++) {
                            var value = filter.valuesArray[j];
                            if (value === item.name) {
                                return true;
                            }
                        }
                    }
                    return false;
                }

                $scope.toggleSelection = function(filter, item) {
                    if (!filter.valuesArray) {
                        filter.valuesArray = [];
                    }

                    var found = false;
                    angular.forEach(filter.valuesArray, function(value, index) {
                        if (value === item.name) {
                            filter.valuesArray.splice(index, 1);
                            found = true;
                        }
                    });

                    if (!found) {
                        filter.valuesArray.push(item.name);
                    }
                }

                $scope.addFilter = function () {
                    FilterService.currentFilters.push(angular.copy($scope.filter));
                };

                $scope.doFilter = function () {
                    if (FilterService.currentFilters.length > 0) {
                        var withErrors = false;
                        angular.forEach(FilterService.currentFilters, function (filter) {
                            if (!filter.parameter || !filter.operand || (!filter.value && filter.operand !== 'IN') || ((!filter.valuesArray || filter.valuesArray.length === 0) && filter.operand === 'IN')) {
                                withErrors = true;
                            }
                        });
                        if (withErrors) {
                            alert('Filtrui(-ams) nenurodytas (-ti) parametras (-ai) arba operandas (-ai)');
                            return;
                        }
                        FilterService.currentFilters[0].operation = 'AND';
                    }
                    $scope.dataService.refreshData(FilterService.currentFilters);
                    FilterService.filters = FilterService.currentFilters;
                };

                var multiselectClickOutsideHandler = function(event) {
                    if (!event.target.closest('.custom-multiselect')) {
                        angular.forEach(FilterService.currentFilters, function(item) {
                            if (item.isMultiselectOpen) {
                                item.isMultiselectOpen = false;
                                $scope.$apply();
                            }
                        });
                        $scope.$apply();
                    }
                }

                document.addEventListener('click', multiselectClickOutsideHandler);

                $scope.$on('$destroy', function() {
                    if (multiselectClickOutsideHandler) {
                        document.removeEventListener('click', multiselectClickOutsideHandler);
                    }
                });
            }]);
})();

(function () {

    'use strict';

    angular.module('filter')
        .directive('filter', ['FilterService', 'filterConfigService', 'DataService', 'dataConfigService', function (FilterService, filterConfigService, DataService, dataConfigService) {
            return {
                templateUrl: 'layout/filter/filterElement.html',
                link: function (scope) {
                    scope.regions = _.orderBy(DataService.getRegions(), 'pavadinimas');
                    scope.services = _.orderBy(DataService.getRoadServices(), 'pavadinimas');
                    scope.masteries = _.orderBy(DataService.getMasteries(), 'pavadinimas');
                    scope.violations = _.orderBy(DataService.getViolations(), 'pavadinimas');
                    scope.statuses = _.orderBy(DataService.getStatus(), 'pavadinimas');
                    scope.workTypes = _.orderBy(DataService.getWorkTypes(), 'pavadinimas');

                    FilterService.currentFilters = angular.copy(FilterService.filters);
                    scope.filters = FilterService.currentFilters;
                    scope.dataConfig = dataConfigService.config;

                    scope.roadAutocompleteUrl = filterConfigService.roadAutocompleteURL;
                    scope.userAutocompleteUrl = filterConfigService.userAutocompleteURL;

                    scope.remove = function (index) {
                        scope.filters.splice(index, 1);
                    };

                    scope.parameterSelected = function (item, index) {
                        item.parameterConfig = getParameterConfigByParameter(item.parameter);
                        item.type = item.parameterConfig.type;
                        if (item.parameterConfig.operands.indexOf(item.operand) === -1) {
                            item.operand = item.parameterConfig.operands[0];
                        }
                        item.value = null;
                        item.roadName = null;
                        scope.$broadcast('angucomplete-alt:clearInput', 'road' + index);
                    };

                    //angucomplete onselect
                    scope.selectRoad = function (selectedItem) {
                        if (selectedItem) {
                            scope.filters[scope.focusedIndex].value = selectedItem.originalObject.id;
                            //save name for repeated angucomplete initialisation
                            scope.filters[scope.focusedIndex].roadName = selectedItem.originalObject.numeris + ' ' + selectedItem.originalObject.pavadinimas;
                        }
                    };

                    //angucomplete onselect
                    scope.selectUser = function (selectedItem) {
                        if (selectedItem) {
                            scope.filters[scope.focusedIndex].value = selectedItem.originalObject.id;
                            //save name for repeated angucomplete initialisation
                            scope.filters[scope.focusedIndex].fullName = selectedItem.originalObject.name + ' ' + selectedItem.originalObject.surname;
                        }
                    };

                    //angucomplete onfocus
                    scope.focusIn = function (index) {
                        scope.focusedIndex = index;
                    };

                    function getParameterConfigByParameter(parameter) {
                        var returnValue;
                        angular.forEach(scope.dataConfig, function (item) {
                            if (item.parameter === parameter) {
                                returnValue = item;
                            }
                        });
                        return returnValue;
                    }
                }
            };
        }]);
})();

(function () {
    'use strict';

    angular.module('filter')
        .service('FilterService', function () {
            var defaultStatusFilter = {
                'parameter': 'defectStatus',
                'operand': 'IN',
                'operation': 'AND',
                'valuesArray': ['NEW', 'READ', 'SOLVING', 'SEEN_BY_LAKD'],
                'type': 'status',
                'parameterConfig': { 'operands': ['=', '<>', 'IN'] }
            };
            var defaultWorkTypeFilter = {
                'parameter': 'workType',
                'operand': '<>',
                'operation': 'AND',
                'value': 'INFORMING_LAKD',
                'type': 'workType',
                'parameterConfig': { 'operands': ['=', '<>'] }
            }
            return {
                filters: [defaultStatusFilter, defaultWorkTypeFilter],
                currentFilters: [],
            };
        });
})();

(function () {
    'use strict';

    angular.module('core')
        .service('dialogService', ['ngDialog', function (ngDialog) {

            function resolve(primary, def) {
                if (angular.isDefined(primary) && primary !== null) {
                    return primary;
                } else {
                    return def;
                }
            }

            return {
                error: function (text, title, ok) {
                    ngDialog.open({
                        template: 'layout/dialogs/error.html',
                        className: 'ngdialog-theme-default',
                        data: {
                            text: text,
                            title: resolve(title, 'Klaida'),
                            ok: resolve(ok, 'Uždaryti')
                        }
                    });
                },
                success: function (text, title, ok) {
                    ngDialog.open({
                        template: 'layout/dialogs/success.html',
                        className: 'ngdialog-theme-default',
                        data: {
                            text: text,
                            title: resolve(title, 'Gerai'),
                            ok: resolve(ok, 'Uždaryti')
                        }
                    });
                },
                confirm: function (text, title, ok, cancel) {
                    return ngDialog.openConfirm({
                        template: 'layout/dialogs/confirm.html',
                        className: 'ngdialog-theme-default',
                        closeByDocument: false,
                        closeByEscape: false,
                        data: {
                            text: text,
                            title: resolve(title, 'Patvirtinimas'),
                            ok: resolve(ok, 'Patvirtinti'),
                            cancel: resolve(cancel, 'Atšaukti')
                        }
                    });
                },
                confirmCustom: function (templateUrl, params) {
                    return ngDialog.openConfirm({
                        template: templateUrl,
                        className: 'ngdialog-theme-default',
                        closeByDocument: false,
                        closeByEscape: false,
                        data: {
                            params: params
                        }
                    });
                },
                blockingDialog: function(promise, title, initialText, clazz) {
                    return ngDialog.open({
                        template: 'layout/dialogs/blockingDialog.html',
                        className: 'ngdialog-theme-default',
                        appendClassName: clazz,
                        closeByDocument: false,
                        closeByEscape: false,
                        showClose: false,
                        data: {
                            text: resolve(initialText, ''),
                            title: resolve(title, 'Prašome palaukti...'),
                            promise: promise
                        },
                        controller: ['$scope', function($scope) {
                            $scope.ngDialogData.promise.then(
                                function(success) {
                                    var timeout = success == null ? 0 : 2000;
                                    $scope.ngDialogData.text = resolve(success, $scope.text);
                                    $scope.showClose = true;
                                    $scope.success = true;
                                    setTimeout(function() {
                                        $scope.closeThisDialog();
                                    }, timeout);
                                },
                                function(fail) {
                                    $scope.ngDialogData.text = resolve(fail, $scope.text);
                                    $scope.showClose = true;
                                    $scope.fail = true;
                                },
                                function(progress) {
                                    $scope.ngDialogData.text = resolve(progress, $scope.text);
                                }
                            );
                        }]
                    });
                },
                customBlockingDialog: function(template, args, promise, title, initialText, clazz) {
                    return ngDialog.open({
                        template: template,
                        className: 'ngdialog-theme-default',
                        appendClassName: clazz,
                        closeByDocument: false,
                        closeByEscape: false,
                        showClose: false,
                        data: {
                            text: resolve(initialText, ''),
                            title: resolve(title, 'Prašome palaukti...'),
                            promise: promise
                        },
                        controller: ['$scope', function($scope) {
                            args['$scope'] = $scope;
                            $scope.ngDialogData.promise.then(
                                function(success) {
                                    if(args['success']) {
                                        args['success'](success);
                                        return;
                                    }
                                    var timeout = success == null ? 0 : 2000;
                                    $scope.ngDialogData.text = resolve(success, $scope.text);
                                    $scope.showClose = true;
                                    $scope.success = true;
                                    setTimeout(function() {
                                        $scope.closeThisDialog();
                                    }, timeout);
                                },
                                function(fail) {
                                    if(args['fail']) {
                                        args['fail'](fail);
                                        return;
                                    }
                                    $scope.ngDialogData.text = resolve(fail, $scope.text);
                                    $scope.showClose = true;
                                    $scope.fail = true;
                                },
                                function(progress) {
                                    if(args['progress']) {
                                        args['progress'](progress);
                                        return;
                                    }
                                    $scope.ngDialogData.text = resolve(progress, $scope.text);
                                }
                            );
                            $scope.get = function(name) {
                                return args[name];
                            };
                        }]
                    });
                },
                reportExportBlockingDialog: function(promise) {
                    return ngDialog.open({
                        template: 'layout/dialogs/blockingDialog.html',
                        className: 'ngdialog-theme-default',
                        closeByDocument: false,
                        closeByEscape: false,
                        showClose: false,
                        data: {
                            text: 'Prašome palaukti...',
                            title: 'Failas ruošiamas',
                            promise: promise
                        },
                        controller: ['$scope', function($scope) {
                            $scope.ngDialogData.promise.then(
                                function() {
                                    $scope.showClose = true;
                                    $scope.success = true;
                                    $scope.closeThisDialog();
                                },
                                function() {
                                    $scope.showClose = true;
                                    $scope.fail = true;
                                    $scope.closeThisDialog();
                                },
                                function(progress) {
                                    $scope.ngDialogData.text = resolve(progress, $scope.text);
                                }
                            );
                        }]
                    });
                }
            };
        }]);

})();

(function () {
    'use strict';

    angular.module('core')
        .controller('LoginController', ['$scope', '$location', 'userService', loginController]);

    function loginController($scope, $location, userService) {

        var search = $location.search();
        if (search) {
            $scope.noRights = search.info === 'no-rights';
            $scope.logoutInfo = search.info === 'logout';
        }

        $scope.login = function () {
            userService.login();
        };

        $scope.logout = function () {
            userService.logout();
        };
    }
})();


(function () {
    'use strict';
    angular.module('core')
        .service('keycloakService', keycloakService);

    keycloakService.$inject = ['keycloakConfig'];
    function keycloakService(keycloakConfig) {
        var service = this;
        service.keycloak = new Keycloak(keycloakConfig);

        return {
            login: login,
            logout: logout,
            getAccessToken: getAccessToken,
            getResourceAccess: getResourceAccess,
            updateAccessToken: updateAccessToken,
            getInitPromise: getInitPromise
        };

        ///////////////////////////

        function login(path) {
            if (!path) {
                path = '/map?logged-in';
            }
            if (path.indexOf('?' === -1)) {
                // keycloak appends parameters with '&' so we need to work-around by adding first parameter with `?`
                path += '?logged-in';
            }
            service.initPromise = service.keycloak.init({
                onLoad: 'login-required',
                redirectUri: window.location.href.split('#')[0] + '#' + path
            });
            return service.initPromise;
        }

        function logout(path) {
            if (!path) {
                path = '/login?info=logout';
            }
            service.keycloak.logout({ redirectUri: window.location.href.split('#')[0] + '#' + path });
        }

        function getAccessToken() {
            return service.keycloak.token;
        }

        function getResourceAccess() {
            return service.keycloak.resourceAccess[keycloakConfig.clientId];
        }

        function updateAccessToken() {
            service.keycloak.updateToken(keycloakConfig.accessTokenMinValidity);
        }

        function getInitPromise() {
            return service.initPromise
        }
    }

})();

(function () {
    'use strict';

    angular.module('gallery')
        .service('GalleryConfigService', GalleryConfigService);

    GalleryConfigService.$inject = ['serviceBase'];
    function GalleryConfigService(serviceBase) {
        return {
            deleteImageURL: serviceBase + '/road-monitoring/image/remove/',
            getImageListURL: serviceBase + '/road-monitoring/image/list/',
            getImageURL: serviceBase + '/road-monitoring/image/',
            postImageURL: serviceBase + '/road-monitoring/image/'
        };
    }
})();

(function () {
    'use strict';

    angular.module('gallery')
        .controller('GalleryController', ['$scope', 'GalleryService', function ($scope, GalleryService) {
                $scope.listMaximized = true;
                $scope.object = GalleryService.getCurrentObject();
            }]
        );
})();

(function () {
    'use strict';

    directiveController.$inject = ['$scope', 'dialogService', 'GalleryService', 'GalleryConfigService', 'KeypressService', '$window', 'userService'];
    angular.module('gallery')
        .directive('gallery', gallery);

    function gallery() {
        return {
            restrict: 'E',
            templateUrl: 'layout/galleryTemplate.html',
            scope: {
                listMaximized: '=',
                object: '=',
                onSuccess: '&'
            },
            controller: directiveController
        };
    }

    function directiveController($scope, dialogService, GalleryService, GalleryConfigService, KeypressService, $window, userService) {
        $scope.images = ['loading'];
        $scope.listenerIDs = [];
        $scope.current = 0;

        angular.element(document).ready(function () {
            document.querySelector('#gallery-upload-wrapper-drop').click();
            document.querySelector('#gallery-upload-wrapper-drop').focus();
        });

        activate();

        $scope.nextImage = function (event) {//go to next image
            $scope.current = ($scope.current + 1) % $scope.images.length;
            if (event != undefined) {
                $scope.$apply();
            }
        };

        $scope.prevImage = function (event) {//go to previous image
            $scope.current--;
            if ($scope.current < 0) {
                $scope.current = $scope.images.length + $scope.current;
            }
            if (event != undefined) {
                $scope.$apply();
            }
        };

        $scope.isCurrent = function (index) {//check if image is current
            return index === $scope.current;
        };

        $scope.selectImage = function (index) {//select an image
            $scope.current = index;
        };

        $scope.openImage = function (index) {//open image in new tab/window
            var wind = window.open('about:blank', '_blank');
            var img = new Image();
            img.src = $scope.images[index].url;
            wind.document.getElementsByTagName('body')[0].innerHTML = img.outerHTML;
        };

        $scope.removeImage = function (index) {//remove an image
            dialogService.confirm('Ar tikrai norite trinti nuotrauką?', null, 'Trinti')
                .then(function () {
                    var id = $scope.images[index].id;
                    $scope.images.splice(index, 1);
                    GalleryService.deleteImage(id, function () {
                        loadImages();
                        if ($scope.onSuccess) {
                            $scope.onSuccess();
                        }
                    }, function () {
                        dialogService.error('Įvyko klaida trinant nuotrauką.');
                    });
                });
        }

        $scope.onWindowResize = function () { //handle window resizing (make sure, that the image does not overflow under the floating list)
            var bottom = document.getElementById('gallery-bottom').getBoundingClientRect().bottom;
            document.getElementById('gallery-modal-dialog').style.height = window.innerHeight - 200 + 'px';
            if ($scope.listMaximized)
                bottom -= bottom * 0.25; //subtract the thumb container height
            else bottom -= 25; //bottom position - padding
            var imagedropBoxRect = document.getElementById('image-display').getBoundingClientRect();
            document.getElementById('image-display').style.maxHeight = (bottom - imagedropBoxRect.top - 20) + 'px';
        };

        $scope.galleryInit = function ()//initialize the gallery (load images, and call onWindowResize, after the structure of HTML has loaded)
        {
            $scope.onWindowResize();
        }
        angular.element($window).bind('resize', $scope.onWindowResize);//register the handler

        $scope.cleanUp = function () {//unregister all listeners
            angular.element($window).unbind('resize', $scope.onWindowResize);
            for (var i = 0; i < $scope.listenerIDs.length; i++)
                KeypressService.unregisterKeypressListener($scope.listenerIDs[i]);
            $scope.listenerIDs.splice(0, $scope.listenerIDs.length);
        };

        $scope.$watch('object', loadImages());
        $scope.$on('refreshGallery', loadImages);

        function activate() {
            //register listeners
            $scope.listenerIDs.push(KeypressService.registerKeypressListener(37, $scope.prevImage));
            $scope.listenerIDs.push(KeypressService.registerKeypressListener(39, $scope.nextImage));
        }

        function loadImages() {
            if ($scope.object && $scope.object.id) {
                GalleryService.getImages($scope.object.id, function (data) {
                    $scope.images = _.map(data, function (item) {
                        return {
                            url: 'data:' + item.format + ';base64, ' + item.content,
                            id: item.id,
                            createdByCurrentUser: item.createdByCurrentUser
                        };
                    });

                    $scope.object.nuotraukuKiekis = $scope.images.length;
                    $scope.onWindowResize();
                }, function () {
                    $scope.images.splice(0, $scope.images.length);
                    dialogService.error('Įvyko klaida kraunant nuotraukas iš duomenų bazės.');
                });
            } else {
                dialogService.error('Įvyko klaida inicijuojant galeriją.');
            }
        }

        $scope.$watch('files', function () {
            $scope.upload($scope.files);
        });

        $scope.upload = function (files) {  // ngf functions uploads file
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    GalleryService.uploadImages($scope.object.id, $scope.inputElement, file, function () {
                        $scope.$broadcast('refreshGallery');
                        if ($scope.onSuccess) {
                            $scope.onSuccess();
                        }
                    });
                }
            }
        };

        $scope.canRemoveImage = function (image) {
            return image ? userService.canEditObject(image.createdByCurrentUser) : false;
        }
    }
})();

(function () {
    'use strict';

    angular.module('gallery')
        .service('GalleryService', ['$http', 'GalleryConfigService', 'dialogService', function ($http, GalleryConfigService, dialogService) {
                var object = {};
                return {
                    getCurrentObject: function () {
                        return object;
                    },
                    setCurrentObject: function (obj) {
                        object = obj;
                    },
                    deleteImage: function (ID, success, error) {
                        $http.delete(GalleryConfigService.deleteImageURL + ID)
                            .success(function (data, status, headers, config) {
                                if (angular.isDefined(success)) {
                                    success(data, status, headers, config);
                                }
                            }).
                            error(function (data, status, headers, config) {
                                if (angular.isDefined(error)) {
                                    error(data, status, headers, config);
                                }
                            }
                            );
                    },
                    getImages: function (OID, success, error) {
                        $http.get(GalleryConfigService.getImageListURL + OID).
                            success(function (data, status, headers, config) {
                                if (angular.isDefined(success)) {
                                    success(data, status, headers, config);
                                }
                            }).
                            error(function (data, status, headers, config) {
                                if (angular.isDefined(error)) {
                                    error(data, status, headers, config);
                                }
                            }
                            );
                    },
                    uploadImages: function (OID, inputElement, droppedFile, successCallback) {
                        if (typeof FormData === 'undefined')//IE fallback
                        {
                            var iframe = document.createElement('iframe');
                            iframe.setAttribute('id', 'IEupload');
                            iframe.setAttribute('name', 'IEupload');
                            iframe.setAttribute('width', '0');
                            iframe.setAttribute('height', '0');
                            iframe.setAttribute('border', '0');
                            iframe.setAttribute('src', 'javascript:false;');
                            iframe.style.display = 'none';

                            var form = document.createElement('form');
                            form.setAttribute('target', 'IEupload');
                            form.setAttribute('action', GalleryConfigService.postImageURL + OID);
                            form.setAttribute('method', 'post');
                            form.setAttribute('enctype', 'multipart/form-data');
                            form.setAttribute('encoding', 'multipart/form-data');
                            form.style.display = 'block';

                            form.appendChild(inputElement);

                            document.body.appendChild(form);
                            document.body.appendChild(iframe);
                            var iframeFile = document.getElementById('IEupload');

                            var uploadHandler = function () {
                                if (iframeFile.detachEvent)
                                    iframeFile.detachEvent('onload', uploadHandler);
                                else
                                    iframeFile.removeEventListener('load', uploadHandler, false);
                                form;
                                successCallback();
                            }

                            if (typeof successCallback !== 'undefined') {
                                if (iframeFile.addEventListener)
                                    iframeFile.addEventListener('load', uploadHandler, true);
                                else if (iframeFile.attachEvent)
                                    iframeFile.attachEvent('onload', uploadHandler);
                            }

                            form.submit();
                            return;
                        }

                        var fd = new FormData();
                        if (droppedFile === null) {
                            for (var i = 0; i < inputElement.files.length; i++) {
                                if (inputElement.files[i].type.indexOf('image') === -1) {
                                    dialogService.error('Negalima prisegti failo "' + inputElement.files[i].name + '": Nepalaikomas formatas.');
                                    continue;
                                }
                                fd.append('file', inputElement.files[i]);
                            }
                        } else {
                            fd.append('file', droppedFile);
                        }

                        $http.post(GalleryConfigService.postImageURL + OID, fd, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': undefined }
                        })
                            .success(function () {
                                if (typeof successCallback !== 'undefined')
                                    successCallback();
                            })
                            .error(function () {
                                dialogService.error('Įvyko klaida pridedant nuotraukas prie duomenų bazės.');
                            });
                    }
                };
            }]);
})();

(function () {
    'use strict';

    angular.module('map')
        .service('ArcGISMap', ['$rootScope', '$window', '$http', '$filter', '$timeout', 'editService', 'DataService', 'NotesService', 'mapConfigService', 'GalleryService', 'DocumentService', 'userService', 'dialogService', 'FilterService', function ($rootScope, $window, $http, $filter, $timeout, editService, DataService, NotesService, mapConfigService,
                GalleryService, DocumentService, userService, dialogService, FilterService) {

                var loaded = false;
                var map;
                var securityObjLayer, objectRoadLayer, myLocationLayer, roadMeasurementLayer;
                var dataService = DataService;
                var ctxMenuForMap;
                var searchString;

                var timeoutPromise = {};
                $rootScope.$on('newSearchString', function($event, newSearchString) {
                    searchString = newSearchString;
                    $timeout.cancel(timeoutPromise);
                    timeoutPromise = $timeout(function(){addLayerPoints();}, 400);
                });

                $rootScope.$broadcast('searchStringRequest');

                function search(element) {
                    return DataService.filterData(element, searchString);
                }

                function createMapMenu() {
                    var mapPoint;
                    ctxMenuForMap = new dijit.Menu({
                        onOpen: function (box) {
                            var x = box.x, y = box.y;
                            switch (box.corner) {
                                case 'TR':
                                    x += box.w;
                                    break;
                                case 'BL':
                                    y += box.h;
                                    break;
                                case 'BR':
                                    x += box.w;
                                    y += box.h;
                                    break;
                            }

                            var screenPoint = new esri.geometry.Point(x - map.position.x, y - map.position.y);
                            mapPoint = map.toMap(screenPoint);
                        }
                    });
                    ctxMenuForMap.addChild(new dijit.MenuItem({
                        label: '<button class="btn btn-primary btn-sm info-widget-button" style="width: 100%;"><strong>Naujas</strong></button>',
                        onClick: function () {
                            if (!userService.getPermissions().edit && !userService.getPermissions().editAll) {
                                dialogService.error('', 'Nepakanka teisių');
                                return;
                            }
                            var coords = {
                                geometries: [
                                    {
                                        x: Number(mapPoint.x.toFixed(2)),
                                        y: Number(mapPoint.y.toFixed(2))
                                    }
                                ]
                            };
                            $rootScope.$broadcast('openLocationDialog', coords);
                        }
                    }));
                    ctxMenuForMap.addChild(new dijit.MenuItem({
                        label: '<button class="btn btn-primary btn-sm info-widget-button" style="width: 100%;"><strong>Kelio matavimai</strong></button>',
                        onClick: function () {
                            $rootScope.$broadcast('toggleMeasurements', mapPoint);
                        }
                    }));
                    ctxMenuForMap.startup();
                    ctxMenuForMap.bindDomNode(map.container);
                }

                //angular doesn't parse map info window so we use global variable to pass callback function
                mapCallbacks.editItem = function (itemId) {
                    angular.forEach(dataService.getData(), function (data) {
                        if (itemId == data.id) {
                            editService.obj = data;
                        }
                    });
                    if (editService.obj) {
                         var data = angular.copy(editService.obj);
                            editService.updateStatus(data).then(function(response){
                            DataService.refreshData(FilterService.filters);
                            editService.obj = response.data;
                            $rootScope.Ui.turnOn('edit');
                    });
                    }
                };
                mapCallbacks.showNotes = function (itemId) {
                    NotesService.obj = null;
                    angular.forEach(dataService.getData(), function (data) {
                        if (itemId == data.id) {
                            NotesService.resetNotes();
                            NotesService.obj = angular.copy(data);
                            NotesService.loadNotes();
                        }
                    });
                    if (NotesService.obj) {
                        $rootScope.Ui.turnOn('notes');
                        $rootScope.$apply();
                    }
                };
                mapCallbacks.openStreetView = function (x, y) {
                    if (isNaN(x) || isNaN(y)) {
                        alert('Please enter valid numbers');
                    } else {
                        var inSR = new esri.SpatialReference({
                            wkid: 3346
                        });
                        var outSR = new esri.SpatialReference({
                            wkid: 4258
                        });
                        var geometryService = new esri.tasks.GeometryService(mapConfigService.geometryServiceURL);
                        var inputpoint = new esri.geometry.Point(x, y, inSR);
                        var PrjParams = new esri.tasks.ProjectParameters();
                        PrjParams.geometries = [inputpoint];
                        PrjParams.outSR = outSR;
                        geometryService.project(PrjParams, function (outputpoint) {
                            $window.open(mapConfigService.googleStreetViewURL + outputpoint[0].y + ',' + outputpoint[0].x + '&layer=c', '_blank');
                        });
                    }
                };

                mapCallbacks.openGallery = function (id) {
                    var items = dataService.getData().filter(function (obj) {
                        return obj.id === id;
                    });
                    if (items.length === 0) {
                        return;
                    }
                    GalleryService.setCurrentObject(items[0]);
                    $rootScope.Ui.turnOn('gallery');
                    $rootScope.$apply();
                };

                mapCallbacks.openDocuments = function (id) {
                    var items = dataService.getData().filter(function (obj) {
                        return obj.id === id;
                    });
                    if (items.length === 0) {
                        return;
                    }
                    DocumentService.setCurrentObject(items[0]);
                    $rootScope.$emit('openDocuments');
                    $rootScope.Ui.turnOn('documents');
                    $rootScope.$apply();
                };

                function showInfoWindow(evt) {
                    objectRoadLayer.clear();
                    var kpo = evt.graphic.attributes;
                    var content =
                        '<table class="info-widget-table">' +
                        '   <tr>' +
                        '       <td><strong>Kelias: </strong></td>' +
                        '       <td>' + kpo.kelioNumeris + ' ' + kpo.kelioPavadinimas + '</td>' +
                        '   </tr>' +
                        '   <tr>' +
                        '       <td><strong>Nuo: </strong></td>' +
                        '       <td>' + kpo.kmNuo + ' km </td>' +
                        '   </tr>' +
                        ( kpo.kmIki ?
                        '   <tr>' +
                        '       <td><strong>Iki: </strong></td>' +
                        '       <td>' + kpo.kmIki + ' km </td>' +
                        '   </tr>' : '' ) +
                        ( kpo.padaliniuPavadinimai ?
                            '   <tr>' +
                            '       <td><strong>Regionas: </strong></td>' +
                            '       <td>' + kpo.padaliniuPavadinimai + '</td>' +
                            '   </tr>' : '' ) +
                        (kpo.defektuGrupiuPavadinimai === '' ? '' :
                            '   <tr>' +
                            '       <td><strong>Defektų grupės: </strong></td>' +
                            '       <td>' + kpo.defektuGrupiuPavadinimai + '</td>' +
                            '   </tr>') +
                        ( kpo.aprasymas ?
                            '   <tr>' +
                            '       <td><strong>Aprašymas: </strong></td>' +
                            '       <td>' + kpo.aprasymas.substring(0, 60) + '</td>' +
                            '   </tr>' : '' ) +
                        ( kpo.apziurosData ?
                            '   <tr>' +
                            '       <td><strong>Apžiūros data: </strong></td>' +
                            '       <td>' + $filter('date')(kpo.apziurosData, 'yyyy-MM-dd') + '</td>' +
                            '   </tr>' : '' ) +
                        ( kpo.sprendimoData ?
                            '   <tr>' +
                            '       <td><strong>Išsprendimo data: </strong></td>' +
                            '       <td>' + $filter('date')(kpo.sprendimoData, 'yyyy-MM-dd') + '</td>' +
                            '   </tr>' : '' ) +
                        ( kpo.sukuresNaudotojas ?
                            '   <tr>' +
                            '       <td><strong>Sukūrė: </strong></td>' +
                            '       <td>' + kpo.sukuresNaudotojas + '</td>' +
                            '   </tr>' : '' ) +
                        '</table>' +
                        '</br>' +
                        '<div class="kpo-info-dialog-buttons">' +
                        '   <div class="btn-group">' +
                        '      <button title="Redagavimas" class="edit-btn btn btn-primary btn-sm info-widget-button"><i class="fa fa-info"></i></button> ' +
                        '      <button title="Street View" class="street-view-btn btn btn-primary btn-sm info-widget-button"><i class="fa fa-street-view"></i></button> ' +
                        (kpo.pastabuKiekis ?
                        '      <button title="Pastabos" class="note-btn btn btn-primary btn-sm info-widget-button"><i class="fa fa-comment-o"></i></button> ' :
                        '      <button title="Pastabos" class="note-btn btn btn-primary btn-sm info-widget-button btn-no-records"><i class="fa fa-comment-o"></i></button> ' ) +
                        (kpo.nuotraukuKiekis ?
                        '      <button title="Galerija" class="gallery-btn btn btn-primary btn-sm info-widget-button"><i class="fa fa-image"></i></button> ' :
                        '      <button title="Galerija" class="gallery-btn btn btn-primary btn-sm info-widget-button btn-no-records"><i class="fa fa-image"></i></button> ' ) +
                        (kpo.dokumentuKiekis ?
                        '       <button title="Dokumentai" class="doc-btn btn btn-primary btn-sm info-widget-button"><i class="fa fa-file-text-o"></i></button> ' :
                        '       <button title="Dokumentai" class="doc-btn btn btn-primary btn-sm info-widget-button btn-no-records"><i class="fa fa-file-text-o"></i></button> ' ) +
                        '   </div>' +
                        '</div>';
                    var contentDom = document.createElement('div');
                    contentDom.innerHTML = content;
                    contentDom.querySelector('.edit-btn').addEventListener('click', function() { mapCallbacks.editItem(kpo.id); });
                    contentDom.querySelector('.street-view-btn').addEventListener('click', function() { mapCallbacks.openStreetView(kpo.xnuo, kpo.ynuo); });
                    contentDom.querySelector('.note-btn').addEventListener('click', function() { mapCallbacks.showNotes(kpo.id); });
                    contentDom.querySelector('.gallery-btn').addEventListener('click', function() { mapCallbacks.openGallery(kpo.id); });
                    contentDom.querySelector('.doc-btn').addEventListener('click', function() { mapCallbacks.openDocuments(kpo.id); });

                    map.infoWindow.setTitle('Kelių priežiūros objektas');
                    map.infoWindow.setContent(contentDom);
                    map.infoWindow.resize(350, 'auto');
                    map.infoWindow.show(evt.mapPoint);
                    createPath(kpo, objectRoadLayer);
                }

                function createPath(kpo, layer) {
                    if (!kpo.id || !kpo.kmIki || kpo.kmNuo === kpo.kmIki || !kpo.linijinisObjektas) {//check for geometry data
                        return;
                    }

                    $http.get(mapConfigService.kpoGeometryURL, {params:{id: kpo.id}}).success(function (data) {
                        var line = new esri.geometry.Polyline(new esri.SpatialReference({ wkid: 3346 }));

                        for (var i = 0; i < data.length; i++) {
                            var points = [];

                            for (var j = 0; j < data[i].length; j++) {
                                points.push(
                                    new esri.geometry.Point(data[i][j].x, data[i][j].y, new esri.SpatialReference({ wkid: 3346 }))
                                );
                            }

                            line.addPath(points);
                        }

                        line.addPath(points);
                        var lSymbol = new esri.symbol.SimpleLineSymbol(
                            esri.symbol.SimpleLineSymbol.STYLE_SOLID,
                            new esri.Color([0x00, 0x7A, 0xFF, 0.5]), 3
                        );
                        var lineGraphics = new esri.Graphic(line, lSymbol);
                        layer.add(lineGraphics);
                    })

                }

                function addLayerPoints() {
                        if (!map) {
                            return;
                        }
                        if (!objectRoadLayer) {
                            objectRoadLayer = new esri.layers.GraphicsLayer({
                                id: 'Objekto kelias',
                                visible: true
                            });
                            map.addLayer(objectRoadLayer);
                            window.objectRoadLayer = objectRoadLayer;
                        }
                        if (!securityObjLayer) {
                            securityObjLayer = new esri.layers.GraphicsLayer({
                                id: 'Kelių priežiūros objektai',
                                visible: true
                            });
                            securityObjLayer.on('click', showInfoWindow);
                            map.infoWindow.on('hide', function () {
                                objectRoadLayer.clear();
                            });
                            map.addLayer(securityObjLayer);
                        }

                        objectRoadLayer.clear();
                        securityObjLayer.clear();
                        angular.forEach($filter('filter')(dataService.getData(), search), function (data) {
                            if (data.xnuo && data.ynuo) {
                                var x, y;
                                if (data.ynuo < data.xnuo) {
                                    x = data.ynuo;
                                    y = data.xnuo;
                                } else {
                                    y = data.ynuo;
                                    x = data.xnuo;
                                }
                                var point = new esri.geometry.Point(x, y, new esri.SpatialReference({ wkid: 3346 }));
                                var marker = new esri.Graphic({ 'geometry': point, 'attributes': data });
                                var infoSymbol = new esri.symbol.SimpleMarkerSymbol();
                                if (data.darbuRusis === 'PP') {
                                    infoSymbol.setSize(15, 15);
                                    infoSymbol.setStyle('diamond');
                                }  else if (data.darbuRusis === 'KD') {
                                    infoSymbol.setSize(12, 12);
                                    infoSymbol.setStyle('square');
                                } else if (data.darbuRusis === 'LP') {
                                    infoSymbol.setPath('M 0,0 V 30 H 15 V 25 H 5 V 0 Z');
                                    infoSymbol.setSize(18, 5);
                                    infoSymbol.setOffset(0, 12);
                                } else if (data.darbuRusis === 'IL') {
                                    infoSymbol.setPath('M 8,12 a 6,6 0 1 0 -0.001,0 z m 0,2 h -8 v 6 h 3 v 16 h -3 v 6 h 16 v -6 h -3 v -16 h 3 v -6 z');
                                    infoSymbol.setSize(16, 4);
                                    infoSymbol.setOffset(0, 10);
                                } else {
                                    infoSymbol.setPath('m-5,0q0,2.12891 0.64453,3.49609l7.10938,15.11719q0.3125,0.64453 0.92773,1.01563q0.61523,0.37109 1.31836,0.37109q0.70313,0 1.31836,-0.37109q0.61523,-0.37109 0.9082,-1.01563l7.12891,-15.11719q0.64453,-1.36719 0.64453,-3.49609q0,-4.14063 -2.92969,-7.07031q-2.92969,-2.92969 -7.07031,-2.92969q-4.14063,0 -7.07031,2.92969q-2.92969,2.92969 -2.92969,7.07031z');
                                    infoSymbol.setOffset(0, 12);
                                    infoSymbol.setSize(22, 5);
                                }
                                infoSymbol.setOutline(new esri.symbol.SimpleLineSymbol().setWidth(1));
                                if (data.pazeidimai && data.pazeidimai.length > 0) {
                                    var time = 'N';
                                    if (data.defektoStatusasLowValue === 'DSPR') {
                                        time = 'S';
                                    } else {
                                        if (data.sprendimoData !== null) {
                                            var now = new Date();
                                            var sprendimoData = new Date(data.sprendimoData)
                                            if (now > sprendimoData) {
                                                time = 'V';
                                            } else if ((now.getTime() + 604800000) > sprendimoData) {
                                                time = 'A';
                                            }
                                        }
                                    }
                                    infoSymbol.setColor(new esri.Color(mapConfigService.mapIconConfig[data.defektoStatusasLowValue][time]));
                                } else {
                                    infoSymbol.setColor(new esri.Color([200, 200, 200]));
                                }
                                marker.setSymbol(infoSymbol);
                                securityObjLayer.add(marker);
                            }
                        });
                    }

                return {
                    set: function (element) {
                        if (!loaded) {
                            var initExtent = new esri.geometry.Extent(282154, 5913677, 688555, 6278168, new esri.SpatialReference({ wkid: 3346 }));
                            map = new esri.Map(element[0], {
                                logo: false,
                                extent: initExtent,
                                slider: false,
                                spatialReference: new esri.SpatialReference({ wkid: 3346 })
                            });

                            try {
                                var cachedLayer = new esri.layers.ArcGISTiledMapServiceLayer(
                                    mapConfigService.mapServerTiledURL, { id: 'Georeferencinis pagrindas' });
                                cachedLayer.setMaxScale(2000);
                                map.addLayer(cachedLayer);
                            } catch(err) {
                                onCachedLayerError({target: {}});
                            }
                            var cachedOrthoLayer = new esri.layers.ArcGISTiledMapServiceLayer(
                                mapConfigService.mapOrthoLayerCacheURL, { id: 'Ortofoto pagrindas', visible: false });
                            cachedOrthoLayer.setMaxScale(2000);
                            map.addLayer(cachedOrthoLayer);

                            cachedLayer.on('error', onCachedLayerError);
                            cachedOrthoLayer.on('error', onCachedLayerError);

                            map.on('load', onMapLoad);

                            function onCachedLayerError(args) {
                                if (!args.target.loaded) {
                                    map.destroy();
                                    map = new esri.Map(element[0], {
                                        extent: initExtent,
                                        logo: false,
                                        slider: false
                                    });
                                    var cachedLayer = new esri.layers.ArcGISTiledMapServiceLayer(
                                        mapConfigService.mapServerTiledFallbackURL, { id: 'Georeferencinis pagrindas' });
                                    cachedLayer.setMaxScale(2000);
                                    map.addLayer(cachedLayer);

                                    var cachedOrthoLayer = new esri.layers.ArcGISTiledMapServiceLayer(
                                        mapConfigService.mapOrthoLayerCacheFallbackURL, { id: 'Ortofoto pagrindas', visible: false});
                                    cachedOrthoLayer.setMaxScale(2000);
                                    map.addLayer(cachedOrthoLayer);

                                    map.on('load', onMapLoad);
                                }
                            }

                            function onMapLoad() {
                                addLayerPoints();
                                createMapMenu();

                                myLocationLayer = new esri.layers.GraphicsLayer({
                                    id: 'My_location',
                                    visible: true
                                });
                                map.addLayer(myLocationLayer);

                                roadMeasurementLayer = new esri.layers.GraphicsLayer({
                                    id: 'Road_measurement_layer',
                                    visible: true
                                });
                                map.addLayer(roadMeasurementLayer);

                                //Workaround. Map brokes when window is resized not in map state.
                                //Therefore we hide map when leave and show when entering map state.
                                $rootScope.$on('$routeChangeStart', function (angularEvent, next, current) {
                                    if (current.originalPath.indexOf('/map') !== -1 && next.originalPath.indexOf('/map') === -1) {
                                        map.setVisibility(false);
                                    }
                                    if (current.originalPath.indexOf('/map') === -1 && next.originalPath.indexOf('/map') !== -1) {
                                        map.setVisibility(true);
                                    }
                                });
                            }
                        }

                        loaded = true;
                        return map;
                    },
                    get: function () {
                        return map;
                    },
                    zoomToPoint: function (item) {
                        if (map) {
                            var point = new esri.geometry.Point(item.xnuo, item.ynuo, new esri.SpatialReference({ wkid: 3346 }));
                            var evt = {
                                graphic: {
                                    attributes: item
                                },
                                mapPoint: point
                            };
                            showInfoWindow(evt);
                            map.centerAndZoom(point, 8);
                        }
                    },
                    zoomToMyLocation: function (item) {
                        if (map) {
                            var point = new esri.geometry.Point(item.xnuo, item.ynuo, new esri.SpatialReference({ wkid: 3346 }));
                            var evt = {
                                graphic: {
                                    attributes: item
                                },
                                mapPoint: point
                            };
                            showInfoWindow(evt);
                            map.centerAndZoom(point, 8);
                        }
                    },
                    addLayerPoints: addLayerPoints,
                    showMyLocation: function (x, y) {
                        if (map) {
                            var point = new esri.geometry.Point(x, y, new esri.SpatialReference({ wkid: 3346 }));
                            var marker = new esri.Graphic({ 'geometry': point });
                            var infoSymbol = new esri.symbol.SimpleMarkerSymbol();
                            infoSymbol.setSize(20);
                            infoSymbol.setStyle('x');
                            infoSymbol.setOutline(new esri.symbol.SimpleLineSymbol().setWidth(5).setColor(new esri.Color([200, 0, 200])));
                            marker.setSymbol(infoSymbol);
                            myLocationLayer.add(marker);
                            map.centerAndZoom(point, 9)
                        }
                    },
                    hideMyLocation: function () {
                        if (map) {
                            myLocationLayer.clear();
                        }
                    },
                    showRoadMeasurement: function(x, y) {
                        if (map) {
                            var point = new esri.geometry.Point(x, y, new esri.SpatialReference({ wkid: 3346 }));
                            var marker = new esri.Graphic({ 'geometry': point });
                            var infoSymbol = new esri.symbol.SimpleMarkerSymbol();
                            infoSymbol.setSize(20);
                            infoSymbol.setStyle('x');
                            infoSymbol.setOutline(new esri.symbol.SimpleLineSymbol().setWidth(5).setColor(new esri.Color([200, 0, 0])));
                            marker.setSymbol(infoSymbol);
                            roadMeasurementLayer.clear();
                            roadMeasurementLayer.add(marker);
                            if (map.getZoom() < 6) {
                                map.centerAndZoom(point, 9);
                            } else {
                                map.centerAt(point);
                            }
                        }
                    },
                    hideRoadMeasurement: function() {
                        if (map) {
                            roadMeasurementLayer.clear();
                        }
                    }
                };
            }]);
})();

(function () {
    'use strict';

    angular.module('map')
        .directive('arcgisMap', ['$parse', 'ArcGISMap', '$timeout', function ($parse, ArcGISMap, $timeout) {
            return {
                //works on attribute
                restrict: 'A',
                link: function (scope, element) {
                    dojo.require('esri.map');
                    dojo.require('esri.tasks.GeometryService');
                    dojo.require('esri.tasks.ProjectParameters');
                    dojo.require('esri.symbols.SimpleLineSymbol');
                    dojo.require('esri/toolbars/draw');
                    dojo.require('esri/toolbars/edit');
                    dojo.require('dijit/Menu');
                    dojo.require('dijit/MenuItem');
                    dojo.require('dijit/MenuSeparator');
                    dojo.require('esri/geometry/Point');
                    dojo.require('esri/geometry/ScreenPoint');
                    dojo.require('esri.symbols.SimpleMarkerSymbol');

                    function init() {
                        $timeout(function () {
                            var map = ArcGISMap.set(element);
                            var par = element.parent();
                            element.remove();
                            par.append(map.container);
                        });
                    }

                    dojo.ready(init);
                }
            };
        }]);
})();

(function () {

    'use strict';

    angular.module('map')
        .service('mapConfigService', mapConfigService);

    mapConfigService.$inject = ['arcgisBase', 'serviceBase'];
    function mapConfigService(arcgisBase, serviceBase) {
        return {
            mapServerTiledURL: '//www.geoportal.lt/arcgis/rest/services/geoportal_public/background_Lietuva_3346/MapServer',
            mapOrthoLayerCacheURL: '//www.geoportal.lt/arcgis/rest/services/geoportal_public/background_Lietuva-Misrus-3346/MapServer',
            mapServerTiledFallbackURL: arcgisBase + '/EismoInfo_cache_150224/MapServer',
            mapOrthoLayerCacheFallbackURL: arcgisBase + '/ORT_MISRUS/MapServer',
            googleStreetViewURL: 'https://www.google.lt/maps/?cbll=',
            geometryServiceURL: arcgisBase + '/Utilities/Geometry/GeometryServer',
            kpoGeometryURL: serviceBase + '/road-monitoring/resource/geometry',

            mapIconConfig: {
                DNAU: {
                    V: [255, 0, 0],     //Veluojantis
                    A: [255, 137, 137], //Artejantis
                    N: [146, 208, 80]  //Normalus
                },
                DISP: {
                    V: [191, 191, 191],
                    A: [191, 191, 191],
                    N: [191, 191, 191]
                },
                DPER: {
                    V: [255, 0, 0],
                    A: [255, 137, 137],
                    N: [255, 217, 102]
                },
                DATM: {
                    V: [128, 128, 128],
                    A: [128, 128, 128],
                    N: [128, 128, 128]
                },
                DSPR: {
                    S: [43, 38, 216] // Sprendžiama
                },
                DLAP: {
                  V: [138, 34, 215],
                  A: [138, 34, 215],
                  N: [138, 34, 215]
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('map')
        .controller('MapController', ['$rootScope', '$scope', 'ArcGISMap', '$timeout', mapController]);

    function mapController($rootScope, $scope, ArcGISMap, $timeout) {

        $scope.arcMap = ArcGISMap;

        $rootScope.$on('reloadTable', function () {
            $scope.arcMap.addLayerPoints();
        });

        //angular may hide some elements, so we need to reposition map
        $timeout(function () {
            if ($scope.arcMap.get()) {
                $scope.arcMap.get().reposition();
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('notes')
        .filter('breakLines', breakLines);

    function breakLines() {
        return function (input) {
            return input.replace(/(?:\r\n|\r|\n)/g, '<br />');
        };
    }
})();

(function () {
    'use strict';

    angular.module('notes')
        .service('notesConfigService', notesConfigService);

    notesConfigService.$inject = ['serviceBase'];
    function notesConfigService(serviceBase) {
        return {
            SaveNote: serviceBase + '/road-monitoring/note/',
            GetNotes: serviceBase + '/road-monitoring/note/?p=',
            ModifyNote: serviceBase + '/road-monitoring/note/'
        };
    }
})();

(function () {
    'use strict';

    angular.module('notes')
        .controller('NotesController', ['$scope', 'NotesService', 'DataService', function ($scope, NotesService, DataService) {
                $scope.notesType = DataService.getNotesType();
                $scope.noteType = NotesService.getKTTITypeId($scope.notesType);

                $scope.noteText = null;

                $scope.saveNote = function () {
                    var obj = {
                        tipasId: $scope.noteType,
                        tekstas: $scope.noteText,
                        kelioPrieziurosObjektoId: NotesService.obj.id
                    };
                    NotesService.save(obj);
                    NotesService.obj.pastabuKiekis++;
                    $scope.noteText = null;
                    $scope.$broadcast('reloadNotes');
                };
            }]);

})();

(function () {
    'use strict';

    directiveController.$inject = ['$scope', 'NotesService', 'DataService', 'userService'];
    angular.module('notes')
        .directive('notes', notes);

    function notes() {
        return {
            restrict: 'E',
            templateUrl: 'layout/notesTemplate.html',
            controller: directiveController,
            scope: {
                onEdit: '&'
            }
        };
    }

    function directiveController($scope, NotesService, DataService, userService) {
        $scope.notes = NotesService.getNotes();
        $scope.notesType = DataService.getNotesType();

        $scope.modifyNote = function (index) {
            NotesService.modifyNote($scope.editedNotes.data[index], function (data) {
                $scope.notes.data[index] = data;
                if ($scope.onEdit) {
                    $scope.onEdit();
                }
            });
        }

        $scope.$watch('notes', function () {
            $scope.editedNotes = angular.copy($scope.notes);
            NotesService.obj.pastabuKiekis = $scope.notes.data.length;
        }, true);

        $scope.$on('reloadNotes', function() {
            $scope.notes = NotesService.getNotes();
        });

        $scope.canRemoveNote = function (note) {
            return userService.canEditObject(note.createdByCurrentUser);
        }
    }
})();

(function () {
    'use strict';

    angular.module('notes')
        .service('NotesService', ['$http', 'notesConfigService', 'DataService', function ($http, notesConfigService, DataService) {

            var _notes = { data: [] };

            return {
                obj: null,
                save: function (object) {
                    var that = this;
                    object.tipas = 'B';
                    return $http.put(notesConfigService.SaveNote, object).
                        success(function () {
                            that.loadNotes();
                        }).
                        error(function (data) {
                            return data;
                        });
                },
                resetNotes: function () {
                    _notes = { data: [] };
                },
                getNotes: function () {
                    return _notes;
                },
                loadNotes: function () {
                    var promise = $http.get(notesConfigService.GetNotes + this.obj.id).
                        success(function (data) {
                            _notes.data = data;
                        }).
                        error(function (data) {
                            _notes.data = data;
                        });
                    return promise;
                },
                modifyNote: function (note, onSuccess, onError) {
                    var promise = $http.post(notesConfigService.ModifyNote, note).
                        success(function (data, status, headers, config) {
                            if (angular.isDefined(onSuccess)) {
                                onSuccess(data, status, headers, config);
                            }
                        }).
                        error(function (data, status, headers, config) {
                            if (angular.isDefined(onError)) {
                                onError(data, status, headers, config);
                            }
                        });
                    return promise;
                },
                getKTTITypeId: function () {
                    var types = DataService.getNotesType();
                    for (var i = 0; i < types.length; i++) {
                        if (types[i].meaning === 'Pastabos KTTI') {
                            return types[i].id;
                        }
                    }
                }

            };
        }]);
})();

(function () {
    'use strict';

    angular.module('core')
        .controller('OptionsController', optionsController);

    optionsController.$inject = ['$rootScope', '$scope', 'tableConfigService', 'dataConfigService', 'ArcGISMap'];

    function optionsController($rootScope, $scope, tableConfigService, dataConfigService, ArcGISMap) {
        $scope.dataConfig = dataConfigService.config;
        $scope.tableConfig = tableConfigService;

        $scope.redrawTable = function () {
            $rootScope.$broadcast('redrawTable');
        };

        $scope.arcMap = ArcGISMap;
        $scope.layersVisibility = {
            'Georeferencinis pagrindas': { visible: true, inverse: 'Ortofoto pagrindas' },
            'Ortofoto pagrindas': { visible: false, inverse: 'Georeferencinis pagrindas' },
            'Kelių priežiūros objektai': { visible: true, inverse: null }
        };

        $scope.toggleLayer = function (layerName, stop) {
            var layer = $scope.arcMap.get().getLayer(layerName);
            if (!layer)
                return;
            if (layer.visible && !$scope.layersVisibility[layerName].visible) {
                layer.hide();
            } else if ($scope.layersVisibility[layerName].visible) {
                layer.show();
            }

            if ($scope.layersVisibility[layerName].inverse != null && !stop) {
                var inv = $scope.layersVisibility[layerName].inverse;
                $scope.layersVisibility[inv].visible = !$scope.layersVisibility[layerName].visible;
                $scope.toggleLayer(inv, true);
            }
        };

        $scope.saveColumns = function() {
            dataConfigService.setColumnsToCookie();
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('roadMeasurements')
        .controller('roadMeasurementsController', roadMeasurementsController);

    roadMeasurementsController.$inject = ['$rootScope', '$scope', 'roadMeasurementsService', 'editService', 'dialogService', 'ArcGISMap'];
    function roadMeasurementsController($rootScope, $scope, roadMeasurementsService, editService, dialogService, ArcGISMap) {
        var vm = this;
        vm.measurementData = {};
        vm.currentPoint = {};
        vm.availableMeasurements = [];
        vm.selectedMeasurement;
        vm.loading = true;
        vm.getNext = getNext;
        vm.getPrevious = getPrevious
        vm.measurementChangeHandler = measurementChangeHandler;

        //helpers
        vm.getDirection = getDirection;
        vm.getRoadway = getRoadway;
        vm.closeSideBar = closeSideBar;
        vm.hasNextValue = hasNextValue;

        $rootScope.$on('toggleMeasurements', function (evt, mapPoint) {
            vm.loading = true;
            if (!$rootScope.Ui.isActive('uiSidebarLeft')) {
                $rootScope.Ui.toggle('uiSidebarLeft');
                ArcGISMap.get().resize();
            }
            editService.resolveRoad(mapPoint.x, mapPoint.y).success(function (roadInfo) {
                roadMeasurementsService.getMeasurement({ km: roadInfo.km, road: roadInfo.kelionr }).success(function (data) {
                    vm.measurementData = data;
                }).error(function () {
                    dialogService.error('Šioje vietoje nepavyko rasti kelio matavimų');
                }).finally(hideLoader);
            }).error(function () {
                dialogService.error('Nepavyko nustatyti kelio');
            });
        });

        $scope.$watch(function () { return vm.measurementData }, function () {
            if (vm.measurementData.dist && vm.measurementData.numeris) {
                roadMeasurementsService.getAllMeasurements({ km: vm.measurementData.dist, road: vm.measurementData.numeris })
                    .success(function (data) {
                        vm.availableMeasurements = data;
                    });
            }
            if (vm.measurementData.gpse && vm.measurementData.gpsn) {
                ArcGISMap.showRoadMeasurement(vm.measurementData.gpse, vm.measurementData.gpsn);
            } else {
                ArcGISMap.hideRoadMeasurement();
            }
        })

        ////////////////

        function getNext() {
            vm.loading = true;
            var next = vm.measurementData.kryptis == 1 ?
                roadMeasurementsService.getNextMeasurement : roadMeasurementsService.getPreviousMeasurement;
            var dataToSend = {
                km: vm.measurementData.dist,
                road: vm.measurementData.numeris,
                date: vm.measurementData.matavimoData
            };

            next(dataToSend).success(function (data) {
                vm.measurementData = data;
            }).error(function () {
                dialogService.error('Nepavyko gauti sekančio matavimo arba nebėra matavimų šiame kelyje');
            }).finally(hideLoader);
        }

        function getPrevious() {
            vm.loading = true;
            var previous = vm.measurementData.kryptis == 1 ?
                roadMeasurementsService.getPreviousMeasurement : roadMeasurementsService.getNextMeasurement;
            var dataToSend = {
                km: vm.measurementData.dist,
                road: vm.measurementData.numeris,
                date: vm.measurementData.matavimoData
            };

            previous(dataToSend).success(function (data) {
                vm.measurementData = data;
            }).error(function () {
                dialogService.error('Nepavyko gauti ankstesnio matavimo arba nebėra matavimų šiame kelyje');
            }).finally(hideLoader);
        }

        function measurementChangeHandler() {
            vm.loading = true;
            var dataToSend = {
                km: vm.measurementData.dist,
                road: vm.measurementData.numeris,
                date: vm.measurementData.matavimoData
            };
            roadMeasurementsService.getMeasurement(dataToSend).success(function (data) {
                vm.measurementData = data;
            }).error(function () {
                dialogService.error('Nepavyko gauti ankstesnio matavimo arba nebėra matavimų šiame kelyje');
            }).finally(hideLoader);
        }


        function hasNextValue() {
            var measurementGroup = _.find(vm.availableMeasurements, { matavimoData: vm.measurementData.matavimoData });
            if (measurementGroup) {
                var result = { next: true, previous: true }
                if (measurementGroup.kmNuo == vm.measurementData.dist) {
                    vm.measurementData.kryptis == 1 ? result.previous = false : result.next = false;
                }
                if (measurementGroup.kmIki == vm.measurementData.dist) {
                    vm.measurementData.kryptis == 1 ? result.next = false : result.previous = false;
                }
                return result;
            } else {
                return { next: false, previous: false };
            }
        }

        //helpers

        function getRoadway() {
            if (vm.measurementData && vm.measurementData.vazDaliesInfo) {
                if (vm.measurementData.vazDaliesInfo == 1) return 'Viena/pirma važiuojamoji dalis';
                if (vm.measurementData.vazDaliesInfo == 2) return 'Antra važiuojamoji dalis';
            }
            return null;
        }

        function getDirection() {
            if (vm.measurementData && vm.measurementData.kryptis) {
                if (vm.measurementData.kryptis == 1) return 'Kilometražo didejimo kryptis';
                if (vm.measurementData.kryptis == 2) return 'Kilometražo mažejimo kryptis';
            }
            return null;
        }

        function hideLoader() {
            vm.loading = false;
        }

        function closeSideBar() {
            ArcGISMap.get().resize();
            ArcGISMap.hideRoadMeasurement()
        }
    }
})();

(function() {
'use strict';

    angular
        .module('roadMeasurements')
        .service('roadMeasurementsService', roadMeasurementsService);

    roadMeasurementsService.$inject = ['$http', '$rootScope', 'serviceBase'];
    function roadMeasurementsService($http, $rootScope, serviceBase) {
        var service = this;
        service.RESOURCE_PATH = '/resource/keliu-matavimai';
        service.coords = {};

        service.getMeasurement = getMeasurement;
        service.getNextMeasurement = getNextMeasurement;
        service.getPreviousMeasurement = getPreviousMeasurement;
        service.getAllMeasurements = getAllMeasurements;

        return service;

        ////////////////

        function getMeasurement(query) {
            return $http.get(serviceBase + service.RESOURCE_PATH, {params: query});
        }
        function getNextMeasurement(query) {
            return $http.get(serviceBase + service.RESOURCE_PATH + '/next', {params: query});
        }
        function getPreviousMeasurement(query) {
            return $http.get(serviceBase + service.RESOURCE_PATH + '/previous', {params: query});
        }
        function getAllMeasurements(query) {
            return $http.get(serviceBase + service.RESOURCE_PATH + '/all', {params: query});
        }
    }
})();


(function () {
    'use strict';

    angular.module('table')
        .directive('fixedHeader', fixedHeader)
        .directive('repeatListener', repeatListener);

    fixedHeader.$inject = ['$timeout', '$window'];

    function fixedHeader($timeout, $window) {
        return {
            restrict: 'A',
            link: link
        };

        function link($scope, $elem, $attrs) {
            var elem = $elem[0];
            var navBar = document.getElementsByClassName('navbar-absolute-top')[0];
            var scrollDiv = elem.parentElement;
            var mainHeader = elem.querySelector('#mainHead');
            var duplicateHeader = elem.querySelector('#duplicateHead');
            var mainHeaderColumns = mainHeader.children[0].children;
            var duplicateHeaderColumns = duplicateHeader.children[0].children;

            function scrollHandler() {
                //check if bottom reached. If true, call the function specified in onScrollBottom attr
                if (scrollDiv.scrollTop + scrollDiv.offsetHeight > scrollDiv.scrollHeight - 50) {
                    $scope.$apply($attrs.onScrollBottom);
                }
                //adjust duplicate header position
                duplicateHeader.style.left = (-scrollDiv.scrollLeft + 1) + 'px';
            }

            angular.element(scrollDiv).bind('scroll', scrollHandler);

            function fixHeader() {
                for (var i = 0; i < duplicateHeaderColumns.length; i++) {
                    duplicateHeaderColumns[i].style.width = mainHeaderColumns[i].offsetWidth + 'px';
                }

                duplicateHeader.style.width = mainHeader.offsetWidth + 'px';
                mainHeader.style.top = navBar.offsetHeight + 'px';
                duplicateHeader.style.top = navBar.offsetHeight + 'px';
                duplicateHeader.style.display = 'block';
                elem.style.marginTop = (navBar.clientHeight - 49) + 'px';
            }

            angular.element($window).bind('resize', function () {
                fixHeader();
            });

            $scope.$on('redrawTable', function () {
                setTimeout(fixHeader, 100);
            });

            $scope.$on('newSearchString', function () {
                setTimeout(fixHeader, 100);
            });
        }
    }

    function repeatListener() {
        return function (scope) {
            if (scope.$last) {
                scope.$emit('redrawTable');
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('table')
        .service('tableConfigService', tableConfigService);

        function tableConfigService() {
            return {
                showActions: true,
                normalRow: ['DISP', 'DATM'],
                lakd: 'LAKD'
            }
        }
})();

(function () {
    'use strict';

    angular.module('table')
        .controller('TableController', ['$rootScope', '$scope', '$location', 'editService', 'ArcGISMap', 'DataService', 'NotesService', 'tableConfigService', 'FilterService', 'GalleryService', 'DocumentService', 'dialogService', 'dataConfigService', 'SharedState', '$routeParams', 'keycloakService', function ($rootScope, $scope, $location, editService, ArcGISMap, DataService, NotesService, tableConfigService,
                      FilterService, GalleryService, DocumentService, dialogService, dataConfigService, SharedState, $routeParams, keycloakService) {
                $scope.tableConfig = tableConfigService;
                $scope.data = DataService.getData();
                $scope.dataConfig = dataConfigService.config;
                $scope.maxResult = 50;
                var oldSearchString = '';

                var openedId = $routeParams.id;
                if (openedId) {
                    keycloakService.getInitPromise().then(function(result) {
                        editService.getObjectById(openedId).then(function(response) {
                            if (response) {
                                editService.obj = response.data;
                                SharedState.turnOn('edit');
                            }
                        });
                        return result
                    });
                }

                $scope.editService = editService;
                $scope.notesService = NotesService;

                $rootScope.$on('reloadTable', function () {
                    $scope.data = DataService.getData();
                    $scope.maxResult = 50;
                });

                $scope.$on('newSearchString', function($event, newSearchString) {
                    if (newSearchString && newSearchString.length == 1 && oldSearchString.length < 1) {
                      for (var i = 0; i < $scope.data.length; i++) {
                        if ($scope.data[i].selectedRec) {
                            $scope.data[i].selectedRec = false;
                        }
                      }
                    }
                    oldSearchString = newSearchString;
                    $scope.searchString = newSearchString;
                });

                $scope.$emit('searchStringRequest');

                $scope.search = function(element) {
                    return DataService.filterData(element, $scope.searchString);
                };

                $scope.setOrder = function (config) {
                    if (config.order == '') {
                        config.order = '+';
                    } else if (config.order == '+') {
                        config.order = '-'
                    } else if (config.order == '-') {
                        config.order = ''
                    }

                    $scope.$emit('redrawTable');
                };

                $scope.getOrder = dataConfigService.getOrder;

                $scope.openGallery = function (item) {
                    GalleryService.setCurrentObject(item);
                }

                $scope.openDocuments = function (item) {
                    DocumentService.setCurrentObject(item);
                    $scope.$emit('openDocuments');
                }

                $scope.showNotes = function (obj) {
                    $scope.notesService.resetNotes();
                    $scope.notesService.obj = obj;
                    $scope.notesService.loadNotes();
                };

                $scope.showEdit = function (editableObject, editableField) {
                    var data = angular.copy(editableObject);
                    editService.updateStatus(data).then(function(response){
                        DataService.refreshData(FilterService.filters);
                        response.data.focus = editableField;
                        editService.obj = response.data;
                        SharedState.turnOn('edit');
                    });
                };

                $scope.clone = function (clonableObject) {
                    $scope.editService.obj = angular.copy(clonableObject);
                    $scope.editService.obj.id = null;
                };

                $scope.markOnMap = function (item) {
                    if (item.xnuo && item.ynuo) {
                        ArcGISMap.zoomToPoint(item);
                        $location.path('/map');
                    } else {
                        alert('Kelių priežiūros objektui nenurodytos pradžios koordinatės');
                    }
                };

                $scope.bottomReached = function () {
                    $scope.maxResult += 50;
                };

                $scope.remove = function (id) {
                    dialogService.confirm('', 'Ar tikrai norite panaikinti kelių priežiūros objektą?', 'trinti').then(function () {
                        $scope.editService.remove(id).success(function () {
                            DataService.refreshData(FilterService.filters);
                        }).error(function (data, status) {
                            dialogService.error(status === 403 ? 'Nepakanka teisių' : 'Įvyko klaida trinant objektą');
                        });
                    });
                };

                function getDays(timeLeft) {
                    return Math.floor(timeLeft / (24 * 60 * 60 * 1000));
                }

                $scope.isCheckTime = function (item) {
                    if (_.includes(tableConfigService.normalRow, item.defektoStatusasLowValue)) {
                        return 'normal';
                    }
                    if (item.sprendimoData != null) {
                        var timeNow = new Date().getTime();
                        var timeLeft = new Date(item.sprendimoData) - timeNow;
                        var timeInDays = getDays(timeLeft);
                        if (timeInDays <= 7 && timeInDays > 1) return 'warn';
                        else if (timeInDays < 2) return 'critical';
                        else return 'normal';
                    }
                    else return 'normal';
                };
            }
        ]);
})();
